export const COUNTRIES_DATA = [
  {
    country: "United States",
    code: "+1",
    states: [
      { name: "Alabama" },
      { name: "Alaska" },
      { name: "Arizona" },
      { name: "Arkansas" },
      { name: "California" },
      { name: "Colorado" },
      { name: "Connecticut" },
      { name: "Delaware" },
      { name: "Florida" },
      { name: "Georgia" },
      { name: "Hawaii" },
      { name: "Idaho" },
      { name: "Illinois" },
      { name: "Indiana" },
      { name: "Iowa" },
      { name: "Kansas" },
      { name: "Kentucky" },
      { name: "Louisiana" },
      { name: "Maine" },
      { name: "Maryland" },
      { name: "Massachusetts" },
      { name: "Michigan" },
      { name: "Minnesota" },
      { name: "Mississippi" },
      { name: "Missouri" },
      { name: "Montana" },
      { name: "Nebraska" },
      { name: "Nevada" },
      { name: "New Hampshire" },
      { name: "New Jersey" },
      { name: "New Mexico" },
      { name: "New York" },
      { name: "North Carolina" },
      { name: "North Dakota" },
      { name: "Ohio" },
      { name: "Oklahoma" },
      { name: "Oregon" },
      { name: "Pennsylvania" },
      { name: "Rhode Island" },
      { name: "South Carolina" },
      { name: "South Dakota" },
      { name: "Tennessee" },
      { name: "Texas" },
      { name: "Utah" },
      { name: "Vermont" },
      { name: "Virginia" },
      { name: "Washington" },
      { name: "West Virginia" },
      { name: "Wisconsin" },
      { name: "Wyoming" }
    ]
  },
  {
    country: "Vietnam",
    code: "+84",
    states: [
      { name: "An Giang" },
      { name: "Bà Rịa–Vũng Tàu" },
      { name: "Bắc Giang" },
      { name: "Bắc Kạn" },
      { name: "Bạc Liêu" },
      { name: "Bắc Ninh" },
      { name: "Bến Tre" },
      { name: "Bình Định" },
      { name: "Bình Dương" },
      { name: "Bình Phước" },
      { name: "Bình Thuận" },
      { name: "Cà Mau" },
      { name: "Cần Thơ" },
      { name: "Cao Bằng" },
      { name: "Đà Nẵng" },
      { name: "Đắk Lắk" },
      { name: "Đắk Nông" },
      { name: "Điện Biên" },
      { name: "Đồng Nai" },
      { name: "Đồng Tháp" },
      { name: "Gia Lai" },
      { name: "Hà Giang" },
      { name: "Hà Nam" },
      { name: "Hà Nội" },
      { name: "Hà Tĩnh" },
      { name: "Hải Dương" },
      { name: "Hải Phòng" },
      { name: "Hậu Giang" },
      { name: "Hòa Bình" },
      { name: "Hưng Yên" },
      { name: "Khánh Hòa" },
      { name: "Kiên Giang" },
      { name: "Kon Tum" },
      { name: "Lai Châu" },
      { name: "Lâm Đồng" },
      { name: "Lạng Sơn" },
      { name: "Lào Cai" },
      { name: "Long An" },
      { name: "Nam Định" },
      { name: "Nghệ An" },
      { name: "Ninh Bình" },
      { name: "Ninh Thuận" },
      { name: "Phú Thọ" },
      { name: "Phú Yên" },
      { name: "Quảng Bình" },
      { name: "Quảng Nam" },
      { name: "Quảng Ngãi" },
      { name: "Quảng Ninh" },
      { name: "Quảng Trị" },
      { name: "Sóc Trăng" },
      { name: "Sơn La" },
      { name: "Tây Ninh" },
      { name: "Thái Bình" },
      { name: "Thái Nguyên" },
      { name: "Thanh Hóa" },
      { name: "Thừa Thiên–Huế" },
      { name: "Tiền Giang" },
      { name: "TP. Hồ Chí Minh" },
      { name: "Trà Vinh" },
      { name: "Tuyên Quang" },
      { name: "Vĩnh Long" },
      { name: "Vĩnh Phúc" },
      { name: "Yên Bái" }
    ]
  },
    {
      country: "Afghanistan",
      code: "+93",
      states: [
        { name: "Badakhshan" },
        { name: "Badghis" },
        { name: "Baghlan" },
        { name: "Balkh" },
        { name: "Bamyan" },
        { name: "Daykundi" },
        { name: "Farah" },
        { name: "Faryab" },
        { name: "Ghazni" },
        { name: "Ghor" },
        { name: "Helmand" },
        { name: "Herat" },
        { name: "Jowzjan" },
        { name: "Kabul" },
        { name: "Kandahar" },
        { name: "Kapisa" },
        { name: "Khost" },
        { name: "Kunar" },
        { name: "Kunduz" },
        { name: "Laghman" },
        { name: "Logar" },
        { name: "Nangarhar" },
        { name: "Nimroz" },
        { name: "Nuristan" },
        { name: "Paktia" },
        { name: "Paktika" },
        { name: "Panjshir" },
        { name: "Parwan" },
        { name: "Samangan" },
        { name: "Sar-e Pol" },
        { name: "Takhar" },
        { name: "Urozgan" },
        { name: "Wardak" },
        { name: "Zabul" }
      ]
    },
    {
      country: "Aland Islands",
      code: "+358",
      states: [
        { name: "Mariehamn" },
        { name: "Jomala" },
        { name: "Finström" },
        { name: "Lemland" },
        { name: "Saltvik" }
      ]
    },
    {
      country: "Albania",
      code: "+355",
      states: [
        { name: "Berat" },
        { name: "Diber" },
        { name: "Durres" },
        { name: "Elbasan" },
        { name: "Fier" },
        { name: "Gjirokaster" },
        { name: "Korce" },
        { name: "Kukes" },
        { name: "Lezhe" },
        { name: "Shkoder" },
        { name: "Tirane" },
        { name: "Vlore" }
      ]
    },
    {
      country: "Algeria",
      code: "+213",
      states: [
        { name: "Adrar" },
        { name: "Chlef" },
        { name: "Laghouat" },
        { name: "Oum El Bouaghi" },
        { name: "Batna" },
        { name: "Bejaia" },
        { name: "Biskra" },
        { name: "Bechar" },
        { name: "Blida" },
        { name: "Bouira" },
        { name: "Tamanrasset" },
        { name: "Tebessa" },
        { name: "Tlemcen" },
        { name: "Tiaret" },
        { name: "Tizi Ouzou" },
        { name: "Algiers" },
        { name: "Djelfa" },
        { name: "Jijel" },
        { name: "Setif" },
        { name: "Saida" },
        { name: "Skikda" },
        { name: "Sidi Bel Abbes" },
        { name: "Annaba" },
        { name: "Guelma" },
        { name: "Constantine" },
        { name: "Medea" },
        { name: "Mostaganem" },
        { name: "M'Sila" },
        { name: "Mascara" },
        { name: "Ouargla" },
        { name: "Oran" },
        { name: "El Bayadh" },
        { name: "Illizi" },
        { name: "Bordj Bou Arréridj" },
        { name: "Boumerdes" },
        { name: "El Tarf" },
        { name: "Tindouf" },
        { name: "Tissemsilt" },
        { name: "El Oued" },
        { name: "Khenchela" },
        { name: "Souk Ahras" },
        { name: "Tipaza" },
        { name: "Mila" },
        { name: "Ain Defla" },
        { name: "Naama" },
        { name: "Ain Temouchent" },
        { name: "Ghardaia" },
        { name: "Relizane" }
      ]
    },
    {
      country: "American Samoa",
      code: "+1684",
      states: [
        { name: "Eastern District" },
        { name: "Western District" },
        { name: "Rose Atoll" },
        { name: "Swains Island" }
      ]
    },
    {
      country: "Andorra",
      code: "+376",
      states: [
        { name: "Andorra la Vella" },
        { name: "Canillo" },
        { name: "Encamp" },
        { name: "Escaldes-Engordany" },
        { name: "La Massana" },
        { name: "Ordino" },
        { name: "Sant Julià de Lòria" }
      ]
    },
    {
      country: "Angola",
      code: "+244",
      states: [
        { name: "Bengo" },
        { name: "Benguela" },
        { name: "Bie" },
        { name: "Cabinda" },
        { name: "Cuando Cubango" },
        { name: "Cuanza Norte" },
        { name: "Cuanza Sul" },
        { name: "Cunene" },
        { name: "Huambo" },
        { name: "Huila" },
        { name: "Luanda" },
        { name: "Lunda Norte" },
        { name: "Lunda Sul" },
        { name: "Malanje" },
        { name: "Moxico" },
        { name: "Namibe" },
        { name: "Uige" },
        { name: "Zaire" }
      ]
    },
    {
      country: "Anguilla",
      code: "+1264",
      states: [
        { name: "Blowing Point" },
        { name: "East End" },
        { name: "George Hill" },
        { name: "Island Harbour" },
        { name: "North Hill" },
        { name: "North Side" },
        { name: "Sandy Ground" },
        { name: "Sandy Hill" },
        { name: "South Hill" },
        { name: "Stoney Ground" },
        { name: "The Farrington" },
        { name: "The Valley" },
        { name: "West End" }
      ]
    },
    {
      country: "Antarctica",
      code: "+672",
      states: [
        { name: "No permanent administrative divisions" }
      ]
    },
    {
      country: "Antigua and Barbuda",
      code: "+1268",
      states: [
        { name: "Barbuda" },
        { name: "Redonda" },
        { name: "Saint George" },
        { name: "Saint John" },
        { name: "Saint Mary" },
        { name: "Saint Paul" },
        { name: "Saint Peter" },
        { name: "Saint Philip" }
      ]
    },
    {
      country: "Argentina",
      code: "+54",
      states: [
        { name: "Buenos Aires" },
        { name: "Catamarca" },
        { name: "Chaco" },
        { name: "Chubut" },
        { name: "Cordoba" },
        { name: "Corrientes" },
        { name: "Entre Rios" },
        { name: "Formosa" },
        { name: "Jujuy" },
        { name: "La Pampa" },
        { name: "La Rioja" },
        { name: "Mendoza" },
        { name: "Misiones" },
        { name: "Neuquen" },
        { name: "Rio Negro" },
        { name: "Salta" },
        { name: "San Juan" },
        { name: "San Luis" },
        { name: "Santa Cruz" },
        { name: "Santa Fe" },
        { name: "Santiago del Estero" },
        { name: "Tierra del Fuego" },
        { name: "Tucuman" }
      ]
    },
    {
      country: "Armenia",
      code: "+374",
      states: [
        { name: "Aragatsotn" },
        { name: "Ararat" },
        { name: "Armavir" },
        { name: "Gegharkunik" },
        { name: "Kotayk" },
        { name: "Lori" },
        { name: "Shirak" },
        { name: "Syunik" },
        { name: "Tavush" },
        { name: "Vayots Dzor" },
        { name: "Yerevan" }
      ]
    },
    {
      country: "Aruba",
      code: "+297",
      states: [
        { name: "No official administrative divisions" }
      ]
    },
    {
      country: "Australia",
      code: "+61",
      states: [
        { name: "New South Wales" },
        { name: "Queensland" },
        { name: "South Australia" },
        { name: "Tasmania" },
        { name: "Victoria" },
        { name: "Western Australia" },
        { name: "Australian Capital Territory" },
        { name: "Northern Territory" }
      ]
    },
    {
      country: "Austria",
      code: "+43",
      states: [
        { name: "Burgenland" },
        { name: "Carinthia" },
        { name: "Lower Austria" },
        { name: "Upper Austria" },
        { name: "Salzburg" },
        { name: "Styria" },
        { name: "Tyrol" },
        { name: "Vorarlberg" },
        { name: "Vienna" }
      ]
    },
    {
        country: "Azerbaijan",
        code: "+994",
        states: [
          { name: "Absheron" },
          { name: "Baku" },
          { name: "Ganja" },
          { name: "Lankaran" },
          { name: "Mingachevir" },
          { name: "Nakhchivan" },
          { name: "Qabala" },
          { name: "Quba" },
          { name: "Shaki" },
          { name: "Shirvan" },
          { name: "Sumqayit" },
          { name: "Tartar" },
          { name: "Yevlakh" },
          { name: "Zaqatala" }
        ]
      },
      {
        country: "Bahamas",
        code: "+1242",
        states: [
          { name: "Acklins" },
          { name: "Berry Islands" },
          { name: "Bimini" },
          { name: "Black Point" },
          { name: "Cat Island" },
          { name: "Crooked Island and Long Cay" },
          { name: "Exuma" },
          { name: "Freeport" },
          { name: "Harbour Island" },
          { name: "Inagua" },
          { name: "Long Island" },
          { name: "Mayaguana" },
          { name: "New Providence" },
          { name: "Ragged Island" },
          { name: "Rum Cay" },
          { name: "San Salvador" }
        ]
      },
      {
        country: "Bahrain",
        code: "+973",
        states: [
          { name: "Capital Governorate" },
          { name: "Northern Governorate" },
          { name: "Southern Governorate" },
          { name: "Muharraq Governorate" }
        ]
      },
      {
        country: "Bangladesh",
        code: "+880",
        states: [
          { name: "Barisal" },
          { name: "Chittagong" },
          { name: "Dhaka" },
          { name: "Khulna" },
          { name: "Mymensingh" },
          { name: "Rajshahi" },
          { name: "Rangpur" },
          { name: "Sylhet" }
        ]
      },
      {
        country: "Barbados",
        code: "+1246",
        states: [
          { name: "Christ Church" },
          { name: "Saint Andrew" },
          { name: "Saint George" },
          { name: "Saint James" },
          { name: "Saint John" },
          { name: "Saint Joseph" },
          { name: "Saint Lucy" },
          { name: "Saint Michael" },
          { name: "Saint Peter" },
          { name: "Saint Philip" },
          { name: "Saint Thomas" }
        ]
      },
      {
        country: "Belarus",
        code: "+375",
        states: [
          { name: "Brest Region" },
          { name: "Gomel Region" },
          { name: "Grodno Region" },
          { name: "Minsk Region" },
          { name: "Mogilev Region" },
          { name: "Vitebsk Region" },
          { name: "City of Minsk" }
        ]
      },
      {
        country: "Belgium",
        code: "+32",
        states: [
          { name: "Antwerp" },
          { name: "East Flanders" },
          { name: "Flemish Brabant" },
          { name: "Hainaut" },
          { name: "Liege" },
          { name: "Limburg" },
          { name: "Luxembourg" },
          { name: "Namur" },
          { name: "Walloon Brabant" },
          { name: "West Flanders" },
          { name: "Brussels-Capital Region" }
        ]
      },
      {
        country: "Belize",
        code: "+501",
        states: [
          { name: "Belize District" },
          { name: "Cayo District" },
          { name: "Corozal District" },
          { name: "Orange Walk District" },
          { name: "Stann Creek District" },
          { name: "Toledo District" }
        ]
      },
      {
        country: "Benin",
        code: "+229",
        states: [
          { name: "Alibori" },
          { name: "Atacora" },
          { name: "Atlantique" },
          { name: "Borgou" },
          { name: "Collines" },
          { name: "Donga" },
          { name: "Kouffo" },
          { name: "Littoral" },
          { name: "Mono" },
          { name: "Oueme" },
          { name: "Plateau" },
          { name: "Zou" }
        ]
      },
      {
        country: "Bermuda",
        code: "+1441",
        states: [
          { name: "Devonshire" },
          { name: "Hamilton" },
          { name: "Paget" },
          { name: "Pembroke" },
          { name: "Sandys" },
          { name: "Smith's" },
          { name: "Southampton" },
          { name: "St. George's" },
          { name: "Warwick" }
        ]
      },
      {
        country: "Bhutan",
        code: "+975",
        states: [
          { name: "Bumthang" },
          { name: "Chhukha" },
          { name: "Dagana" },
          { name: "Gasa" },
          { name: "Haa" },
          { name: "Lhuntse" },
          { name: "Mongar" },
          { name: "Paro" },
          { name: "Pemagatshel" },
          { name: "Punakha" },
          { name: "Samdrup Jongkhar" },
          { name: "Samtse" },
          { name: "Sarpang" },
          { name: "Thimphu" },
          { name: "Trashigang" },
          { name: "Trashiyangtse" },
          { name: "Trongsa" },
          { name: "Tsirang" },
          { name: "Wangdue Phodrang" },
          { name: "Zhemgang" }
        ]
      },
      {
        country: "Bolivia",
        code: "+591",
        states: [
          { name: "Beni" },
          { name: "Chuquisaca" },
          { name: "Cochabamba" },
          { name: "La Paz" },
          { name: "Oruro" },
          { name: "Pando" },
          { name: "Potosi" },
          { name: "Santa Cruz" },
          { name: "Tarija" }
        ]
      },
      {
        country: "Bosnia and Herzegovina",
        code: "+387",
        states: [
          { name: "Federation of Bosnia and Herzegovina" },
          { name: "Republika Srpska" },
          { name: "Brcko District" }
        ]
      },
      {
        country: "Botswana",
        code: "+267",
        states: [
          { name: "Central District" },
          { name: "Ghanzi District" },
          { name: "Kgalagadi District" },
          { name: "Kgatleng District" },
          { name: "Kweneng District" },
          { name: "North East District" },
          { name: "North West District" },
          { name: "South East District" },
          { name: "Southern District" }
        ]
      },
      {
        country: "Bouvet Island",
        code: "+47",
        states: [
          { name: "Uninhabited territory administered by Norway" }
        ]
      },
      {
        country: "Brazil",
        code: "+55",
        states: [
          { name: "Acre" },
          { name: "Alagoas" },
          { name: "Amapá" },
          { name: "Amazonas" },
          { name: "Bahia" },
          { name: "Ceará" },
          { name: "Distrito Federal" },
          { name: "Espírito Santo" },
          { name: "Goiás" },
          { name: "Maranhão" },
          { name: "Mato Grosso" },
          { name: "Mato Grosso do Sul" },
          { name: "Minas Gerais" },
          { name: "Pará" },
          { name: "Paraíba" },
          { name: "Paraná" },
          { name: "Pernambuco" },
          { name: "Piauí" },
          { name: "Rio de Janeiro" },
          { name: "Rio Grande do Norte" },
          { name: "Rio Grande do Sul" },
          { name: "Rondônia" },
          { name: "Roraima" },
          { name: "Santa Catarina" },
          { name: "São Paulo" },
          { name: "Sergipe" },
          { name: "Tocantins" }
        ]
      },
      {
        country: "British Indian Ocean Territory",
        code: "+246",
        states: [
          { name: "Diego Garcia" }
        ]
      },
      {
        country: "Brunei Darussalam",
        code: "+673",
        states: [
          { name: "Belait" },
          { name: "Brunei-Muara" },
          { name: "Temburong" },
          { name: "Tutong" }
        ]
      },
      {
        country: "Bulgaria",
        code: "+359",
        states: [
          { name: "Blagoevgrad" },
          { name: "Burgas" },
          { name: "Dobrich" },
          { name: "Gabrovo" },
          { name: "Haskovo" },
          { name: "Kardzhali" },
          { name: "Kyustendil" },
          { name: "Lovech" },
          { name: "Montana" },
          { name: "Pazardzhik" },
          { name: "Pernik" },
          { name: "Pleven" },
          { name: "Plovdiv" },
          { name: "Razgrad" },
          { name: "Ruse" },
          { name: "Shumen" },
          { name: "Silistra" },
          { name: "Sliven" },
          { name: "Smolyan" },
          { name: "Sofia" },
          { name: "Sofia City" },
          { name: "Stara Zagora" },
          { name: "Targovishte" },
          { name: "Varna" },
          { name: "Veliko Tarnovo" },
          { name: "Vidin" },
          { name: "Vratsa" },
          { name: "Yambol" }
        ]
      },
      {
        country: "Burkina Faso",
        code: "+226",
        states: [
          { name: "Boucle du Mouhoun" },
          { name: "Cascades" },
          { name: "Centre" },
          { name: "Centre-Est" },
          { name: "Centre-Nord" },
          { name: "Centre-Ouest" },
          { name: "Centre-Sud" },
          { name: "Est" },
          { name: "Hauts-Bassins" },
          { name: "Nord" },
          { name: "Plateau-Central" },
          { name: "Sahel" },
          { name: "Sud-Ouest" }
        ]
      },
      {
        country: "Burundi",
        code: "+257",
        states: [
          { name: "Bubanza" },
          { name: "Bujumbura Mairie" },
          { name: "Bujumbura Rural" },
          { name: "Bururi" },
          { name: "Cankuzo" },
          { name: "Cibitoke" },
          { name: "Gitega" },
          { name: "Karuzi" },
          { name: "Kayanza" },
          { name: "Kirundo" },
          { name: "Makamba" },
          { name: "Muramvya" },
          { name: "Muyinga" },
          { name: "Mwaro" },
          { name: "Ngozi" },
          { name: "Rutana" },
          { name: "Ruyigi" }
        ]
      },
      {
        country: "Cambodia",
        code: "+855",
        states: [
          { name: "Banteay Meanchey" },
          { name: "Battambang" },
          { name: "Kampong Cham" },
          { name: "Kampong Chhnang" },
          { name: "Kampong Speu" },
          { name: "Kampong Thom" },
          { name: "Kampot" },
          { name: "Kandal" },
          { name: "Kep" },
          { name: "Koh Kong" },
          { name: "Kratie" },
          { name: "Mondulkiri" },
          { name: "Phnom Penh" },
          { name: "Preah Vihear" },
          { name: "Prey Veng" },
          { name: "Pursat" },
          { name: "Ratanakiri" },
          { name: "Siem Reap" },
          { name: "Sihanoukville" },
          { name: "Stung Treng" },
          { name: "Svay Rieng" },
          { name: "Takeo" },
          { name: "Tbong Khmum" }
        ]
      },
      {
        country: "Cameroon",
        code: "+237",
        states: [
          { name: "Adamawa" },
          { name: "Centre" },
          { name: "East" },
          { name: "Far North" },
          { name: "Littoral" },
          { name: "North" },
          { name: "Northwest" },
          { name: "South" },
          { name: "Southwest" },
          { name: "West" }
        ]
      },
      {
        country: "Canada",
        code: "+1",
        states: [
          { name: "Alberta" },
          { name: "British Columbia" },
          { name: "Manitoba" },
          { name: "New Brunswick" },
          { name: "Newfoundland and Labrador" },
          { name: "Nova Scotia" },
          { name: "Ontario" },
          { name: "Prince Edward Island" },
          { name: "Quebec" },
          { name: "Saskatchewan" },
          { name: "Northwest Territories" },
          { name: "Nunavut" },
          { name: "Yukon" }
        ]
      },
      {
        country: "Cape Verde",
        code: "+238",
        states: [
          { name: "Boa Vista" },
          { name: "Brava" },
          { name: "Maio" },
          { name: "Mosteiros" },
          { name: "Paul" },
          { name: "Porto Novo" },
          { name: "Praia" },
          { name: "Ribeira Brava" },
          { name: "Ribeira Grande" },
          { name: "Sal" },
          { name: "Santa Catarina" },
          { name: "Santa Cruz" },
          { name: "São Domingos" },
          { name: "São Filipe" },
          { name: "São Lourenço dos Órgãos" },
          { name: "São Miguel" },
          { name: "São Vicente" },
          { name: "Tarrafal" }
        ]
      },
      {
        country: "Cayman Islands",
        code: "+1345",
        states: [
          { name: "Bodden Town" },
          { name: "East End" },
          { name: "George Town" },
          { name: "North Side" },
          { name: "Sister Islands" },
          { name: "West Bay" }
        ]
      },
      {
        country: "Central African Republic",
        code: "+236",
        states: [
          { name: "Bamingui-Bangoran" },
          { name: "Bangui" },
          { name: "Basse-Kotto" },
          { name: "Haut-Mbomou" },
          { name: "Haute-Kotto" },
          { name: "Kemo" },
          { name: "Lobaye" },
          { name: "Mambere-Kadei" },
          { name: "Mbomou" },
          { name: "Nana-Grebizi" },
          { name: "Nana-Mambere" },
          { name: "Ombella-Mpoko" },
          { name: "Ouaka" },
          { name: "Ouham" },
          { name: "Ouham-Pende" },
          { name: "Sangha-Mbaere" },
          { name: "Vakaga" }
        ]
      },
      {
        country: "Chad",
        code: "+235",
        states: [
          { name: "Batha" },
          { name: "Borkou" },
          { name: "Chari-Baguirmi" },
          { name: "Guera" },
          { name: "Hadjer-Lamis" },
          { name: "Kanem" },
          { name: "Lac" },
          { name: "Logone Occidental" },
          { name: "Logone Oriental" },
          { name: "Mandoul" },
          { name: "Mayo-Kebbi Est" },
          { name: "Mayo-Kebbi Ouest" },
          { name: "Moyen-Chari" },
          { name: "Ouaddai" },
          { name: "Salamat" },
          { name: "Sila" },
          { name: "Tandjile" },
          { name: "Tibesti" },
          { name: "Wadi Fira" }
        ]
      },
      {
        country: "Chile",
        code: "+56",
        states: [
          { name: "Arica y Parinacota" },
          { name: "Tarapacá" },
          { name: "Antofagasta" },
          { name: "Atacama" },
          { name: "Coquimbo" },
          { name: "Valparaíso" },
          { name: "Metropolitana de Santiago" },
          { name: "Libertador General Bernardo O’Higgins" },
          { name: "Maule" },
          { name: "Ñuble" },
          { name: "Biobío" },
          { name: "La Araucanía" },
          { name: "Los Ríos" },
          { name: "Los Lagos" },
          { name: "Aisén" },
          { name: "Magallanes" }
        ]
      },
      {
        country: "China",
        code: "+86",
        states: [
          { name: "Anhui" },
          { name: "Beijing" },
          { name: "Chongqing" },
          { name: "Fujian" },
          { name: "Gansu" },
          { name: "Guangdong" },
          { name: "Guangxi" },
          { name: "Guizhou" },
          { name: "Hainan" },
          { name: "Hebei" },
          { name: "Heilongjiang" },
          { name: "Henan" },
          { name: "Hubei" },
          { name: "Hunan" },
          { name: "Inner Mongolia" },
          { name: "Jiangsu" },
          { name: "Jiangxi" },
          { name: "Jilin" },
          { name: "Liaoning" },
          { name: "Ningxia" },
          { name: "Qinghai" },
          { name: "Shaanxi" },
          { name: "Shandong" },
          { name: "Shanghai" },
          { name: "Shanxi" },
          { name: "Sichuan" },
          { name: "Tianjin" },
          { name: "Tibet" },
          { name: "Xinjiang" },
          { name: "Yunnan" },
          { name: "Zhejiang" },
          { name: "Hong Kong" },
          { name: "Macau" }
        ]
      },
      {
        country: "Christmas Island",
        code: "+61",
        states: [
          { name: "Flying Fish Cove" }
        ]
      },
      {
        country: "Cocos (Keeling) Islands",
        code: "+61",
        states: [
          { name: "Home Island" },
          { name: "West Island" }
        ]
      },
      {
        country: "Colombia",
        code: "+57",
        states: [
          { name: "Amazonas" },
          { name: "Antioquia" },
          { name: "Arauca" },
          { name: "Atlantico" },
          { name: "Bolivar" },
          { name: "Boyaca" },
          { name: "Caldas" },
          { name: "Caqueta" },
          { name: "Casanare" },
          { name: "Cauca" },
          { name: "Cesar" },
          { name: "Choco" },
          { name: "Cordoba" },
          { name: "Cundinamarca" },
          { name: "Guainia" },
          { name: "Guaviare" },
          { name: "Huila" },
          { name: "La Guajira" },
          { name: "Magdalena" },
          { name: "Meta" },
          { name: "Narino" },
          { name: "Norte de Santander" },
          { name: "Putumayo" },
          { name: "Quindio" },
          { name: "Risaralda" },
          { name: "San Andres y Providencia" },
          { name: "Santander" },
          { name: "Sucre" },
          { name: "Tolima" },
          { name: "Valle del Cauca" },
          { name: "Vaupes" },
          { name: "Vichada" }
        ]
      },
      {
        country: "Comoros",
        code: "+269",
        states: [
          { name: "Anjouan" },
          { name: "Grande Comore" },
          { name: "Moheli" }
        ]
      },
      {
        country: "Congo",
        code: "+242",
        states: [
          { name: "Bouenza" },
          { name: "Brazzaville" },
          { name: "Cuvette" },
          { name: "Cuvette-Ouest" },
          { name: "Kouilou" },
          { name: "Lekoumou" },
          { name: "Likouala" },
          { name: "Niari" },
          { name: "Plateaux" },
          { name: "Pointe-Noire" },
          { name: "Pool" },
          { name: "Sangha" }
        ]
      },
      {
        country: "Congo, The Democratic Republic of the Congo",
        code: "+243",
        states: [
          { name: "Bas-Uele" },
          { name: "Haut-Uele" },
          { name: "Ituri" },
          { name: "Tshopo" },
          { name: "Haut-Lomami" },
          { name: "Haut-Katanga" },
          { name: "Lualaba" },
          { name: "Tanganyika" },
          { name: "Kasai" },
          { name: "Kasai-Central" },
          { name: "Kasai-Oriental" },
          { name: "Kinshasa" },
          { name: "Kongo-Central" },
          { name: "Kwango" },
          { name: "Kwilu" },
          { name: "Lomami" },
          { name: "Mai-Ndombe" },
          { name: "Maniema" },
          { name: "Mongala" },
          { name: "Nord-Kivu" },
          { name: "Nord-Ubangi" },
          { name: "Sankuru" },
          { name: "Sud-Kivu" },
          { name: "Sud-Ubangi" },
          { name: "Tshuapa" }
        ]
      },
      {
        country: "Cook Islands",
        code: "+682",
        states: [
          { name: "Aitutaki" },
          { name: "Atiu" },
          { name: "Mangaia" },
          { name: "Manihiki" },
          { name: "Mauke" },
          { name: "Mitiaro" },
          { name: "Palmerston" },
          { name: "Penrhyn" },
          { name: "Pukapuka" },
          { name: "Rakahanga" },
          { name: "Rarotonga" }
        ]
      },
      {
        country: "Costa Rica",
        code: "+506",
        states: [
          { name: "Alajuela" },
          { name: "Cartago" },
          { name: "Guanacaste" },
          { name: "Heredia" },
          { name: "Limon" },
          { name: "Puntarenas" },
          { name: "San Jose" }
        ]
      },
      {
        country: "Cote d'Ivoire",
        code: "+225",
        states: [
          { name: "Abidjan" },
          { name: "Bas-Sassandra" },
          { name: "Comoe" },
          { name: "Denguele" },
          { name: "Goh-Djiboua" },
          { name: "Lacs" },
          { name: "Lagunes" },
          { name: "Montagnes" },
          { name: "Sassandra-Marahoue" },
          { name: "Savanes" },
          { name: "Vallee du Bandama" },
          { name: "Woroba" },
          { name: "Yamoussoukro" },
          { name: "Zanzan" }
        ]
      },
      {
        country: "Croatia",
        code: "+385",
        states: [
          { name: "Bjelovar-Bilogora" },
          { name: "Brod-Posavina" },
          { name: "Dubrovnik-Neretva" },
          { name: "Istria" },
          { name: "Karlovac" },
          { name: "Koprivnica-Krizevci" },
          { name: "Krapina-Zagorje" },
          { name: "Lika-Senj" },
          { name: "Medimurje" },
          { name: "Osijek-Baranja" },
          { name: "Pozega-Slavonia" },
          { name: "Primorje-Gorski Kotar" },
          { name: "Sibenik-Knin" },
          { name: "Sisak-Moslavina" },
          { name: "Split-Dalmatia" },
          { name: "Varazdin" },
          { name: "Virovitica-Podravina" },
          { name: "Vukovar-Syrmia" },
          { name: "Zadar" },
          { name: "Zagreb County" },
          { name: "City of Zagreb" }
        ]
      },
      {
        country: "Cuba",
        code: "+53",
        states: [
          { name: "Artemisa" },
          { name: "Camaguey" },
          { name: "Ciego de Avila" },
          { name: "Cienfuegos" },
          { name: "Granma" },
          { name: "Guantanamo" },
          { name: "Havana" },
          { name: "Holguin" },
          { name: "Isla de la Juventud" },
          { name: "Las Tunas" },
          { name: "Matanzas" },
          { name: "Mayabeque" },
          { name: "Pinar del Rio" },
          { name: "Sancti Spiritus" },
          { name: "Santiago de Cuba" },
          { name: "Villa Clara" }
        ]
      },
      {
        country: "Cyprus",
        code: "+357",
        states: [
          { name: "Famagusta" },
          { name: "Kyrenia" },
          { name: "Larnaca" },
          { name: "Limassol" },
          { name: "Nicosia" },
          { name: "Paphos" }
        ]
      },
      {
        country: "Czech Republic",
        code: "+420",
        states: [
          { name: "Central Bohemian" },
          { name: "Hradec Králové" },
          { name: "Karlovy Vary" },
          { name: "Liberec" },
          { name: "Moravian-Silesian" },
          { name: "Olomouc" },
          { name: "Pardubice" },
          { name: "Plzeň" },
          { name: "Prague" },
          { name: "South Bohemian" },
          { name: "South Moravian" },
          { name: "Ústí nad Labem" },
          { name: "Vysočina" },
          { name: "Zlín" }
        ]
      },
      {
        country: "Denmark",
        code: "+45",
        states: [
          { name: "Capital Region" },
          { name: "Central Jutland" },
          { name: "North Jutland" },
          { name: "Zealand" },
          { name: "Southern Denmark" }
        ]
      },
      {
        country: "Djibouti",
        code: "+253",
        states: [
          { name: "Ali Sabieh" },
          { name: "Arta" },
          { name: "Dikhil" },
          { name: "Djibouti" },
          { name: "Obock" },
          { name: "Tadjourah" }
        ]
      },
      {
        country: "Dominica",
        code: "+1767",
        states: [
          { name: "Saint Andrew" },
          { name: "Saint David" },
          { name: "Saint George" },
          { name: "Saint John" },
          { name: "Saint Joseph" },
          { name: "Saint Luke" },
          { name: "Saint Mark" },
          { name: "Saint Patrick" },
          { name: "Saint Paul" },
          { name: "Saint Peter" }
        ]
      },
      {
        country: "Dominican Republic",
        code: "+1849",
        states: [
          { name: "Distrito Nacional" },
          { name: "Azua" },
          { name: "Baoruco" },
          { name: "Barahona" },
          { name: "Dajabón" },
          { name: "Duarte" },
          { name: "El Seibo" },
          { name: "Elias Piña" },
          { name: "Espaillat" },
          { name: "Hato Mayor" },
          { name: "Hermanas Mirabal" },
          { name: "Independencia" },
          { name: "La Altagracia" },
          { name: "La Romana" },
          { name: "La Vega" },
          { name: "María Trinidad Sánchez" },
          { name: "Monseñor Nouel" },
          { name: "Monte Cristi" },
          { name: "Monte Plata" },
          { name: "Pedernales" },
          { name: "Peravia" },
          { name: "Puerto Plata" },
          { name: "Samaná" },
          { name: "San Cristóbal" },
          { name: "San José de Ocoa" },
          { name: "San Juan" },
          { name: "San Pedro de Macorís" },
          { name: "Sánchez Ramírez" },
          { name: "Santiago" },
          { name: "Santiago Rodríguez" },
          { name: "Santo Domingo" },
          { name: "Valverde" }
        ]
      },
      {
        country: "Ecuador",
        code: "+593",
        states: [
          { name: "Azuay" },
          { name: "Bolívar" },
          { name: "Cañar" },
          { name: "Carchi" },
          { name: "Chimborazo" },
          { name: "Cotopaxi" },
          { name: "El Oro" },
          { name: "Esmeraldas" },
          { name: "Galápagos" },
          { name: "Guayas" },
          { name: "Imbabura" },
          { name: "Loja" },
          { name: "Los Ríos" },
          { name: "Manabí" },
          { name: "Morona Santiago" },
          { name: "Napo" },
          { name: "Orellana" },
          { name: "Pastaza" },
          { name: "Pichincha" },
          { name: "Santa Elena" },
          { name: "Santo Domingo de los Tsáchilas" },
          { name: "Sucumbíos" },
          { name: "Tungurahua" },
          { name: "Zamora-Chinchipe" }
        ]
      },
      {
        country: "Egypt",
        code: "+20",
        states: [
          { name: "Alexandria" },
          { name: "Aswan" },
          { name: "Asyut" },
          { name: "Beheira" },
          { name: "Beni Suef" },
          { name: "Cairo" },
          { name: "Dakahlia" },
          { name: "Damietta" },
          { name: "Faiyum" },
          { name: "Gharbia" },
          { name: "Giza" },
          { name: "Ismailia" },
          { name: "Kafr el-Sheikh" },
          { name: "Luxor" },
          { name: "Matruh" },
          { name: "Minya" },
          { name: "Monufia" },
          { name: "New Valley" },
          { name: "North Sinai" },
          { name: "Port Said" },
          { name: "Qalyubia" },
          { name: "Qena" },
          { name: "Red Sea" },
          { name: "Sharqia" },
          { name: "Sohag" },
          { name: "South Sinai" },
          { name: "Suez" }
        ]
      },
      {
        country: "El Salvador",
        code: "+503",
        states: [
          { name: "Ahuachapán" },
          { name: "Cabañas" },
          { name: "Chalatenango" },
          { name: "Cuscatlán" },
          { name: "La Libertad" },
          { name: "La Paz" },
          { name: "La Unión" },
          { name: "Morazán" },
          { name: "San Miguel" },
          { name: "San Salvador" },
          { name: "San Vicente" },
          { name: "Santa Ana" },
          { name: "Sonsonate" },
          { name: "Usulután" }
        ]
      },
      {
        country: "Equatorial Guinea",
        code: "+240",
        states: [
          { name: "Annobón" },
          { name: "Bioko Norte" },
          { name: "Bioko Sur" },
          { name: "Centro Sur" },
          { name: "Kié-Ntem" },
          { name: "Litoral" },
          { name: "Wele-Nzas" }
        ]
      },
      {
        country: "Eritrea",
        code: "+291",
        states: [
          { name: "Anseba" },
          { name: "Debub" },
          { name: "Debubawi Keyih Bahri" },
          { name: "Gash-Barka" },
          { name: "Maekel" },
          { name: "Semienawi Keyih Bahri" }
        ]
      },
      {
        country: "Estonia",
        code: "+372",
        states: [
          { name: "Harju" },
          { name: "Hiiu" },
          { name: "Ida-Viru" },
          { name: "Järva" },
          { name: "Jõgeva" },
          { name: "Lääne" },
          { name: "Lääne-Viru" },
          { name: "Pärnu" },
          { name: "Põlva" },
          { name: "Rapla" },
          { name: "Saare" },
          { name: "Tartu" },
          { name: "Valga" },
          { name: "Viljandi" },
          { name: "Võru" }
        ]
      },
      {
        country: "Ethiopia",
        code: "+251",
        states: [
          { name: "Addis Ababa" },
          { name: "Afar" },
          { name: "Amhara" },
          { name: "Benishangul-Gumuz" },
          { name: "Dire Dawa" },
          { name: "Gambela" },
          { name: "Harari" },
          { name: "Oromia" },
          { name: "Sidama" },
          { name: "Somali" },
          { name: "Southern Nations, Nationalities, and Peoples" },
          { name: "South West Ethiopia Peoples" },
          { name: "Tigray" }
        ]
      },
      {
        country: "Falkland Islands",
        code: "+500",
        states: [
          { name: "East Falkland" },
          { name: "West Falkland" }
        ]
      },
      {
        country: "Faroe Islands",
        code: "+298",
        states: [
          { name: "Eysturoy" },
          { name: "Nordoyar" },
          { name: "Sandoy" },
          { name: "Streymoy" },
          { name: "Suduroy" },
          { name: "Vagar" }
        ]
      },
      {
        country: "Fiji",
        code: "+679",
        states: [
          { name: "Ba" },
          { name: "Bua" },
          { name: "Cakaudrove" },
          { name: "Kadavu" },
          { name: "Lau" },
          { name: "Lomaiviti" },
          { name: "Macuata" },
          { name: "Nadroga-Navosa" },
          { name: "Naitasiri" },
          { name: "Namosi" },
          { name: "Ra" },
          { name: "Rewa" },
          { name: "Serua" },
          { name: "Tailevu" }
        ]
      },
      {
        country: "Finland",
        code: "+358",
        states: [
          { name: "Åland" },
          { name: "Lapland" },
          { name: "Oulu" },
          { name: "Southern Finland" },
          { name: "Eastern Finland" },
          { name: "Western Finland" }
        ]
      },
      {
        country: "France",
        code: "+33",
        states: [
          { name: "Auvergne-Rhône-Alpes" },
          { name: "Bourgogne-Franche-Comté" },
          { name: "Brittany" },
          { name: "Centre-Val de Loire" },
          { name: "Corsica" },
          { name: "Grand Est" },
          { name: "Hauts-de-France" },
          { name: "Île-de-France" },
          { name: "Normandy" },
          { name: "Nouvelle-Aquitaine" },
          { name: "Occitanie" },
          { name: "Pays de la Loire" },
          { name: "Provence-Alpes-Côte d’Azur" }
        ]
      },
      {
        country: "French Guiana",
        code: "+594",
        states: [
          { name: "Cayenne" },
          { name: "Saint-Laurent-du-Maroni" }
        ]
      },
      {
        country: "French Polynesia",
        code: "+689",
        states: [
          { name: "Îles du Vent" },
          { name: "Îles Sous-le-Vent" },
          { name: "Tuamotu-Gambier" },
          { name: "Marquises" },
          { name: "Australes" }
        ]
      },
      {
        country: "Gabon",
        code: "+241",
        states: [
          { name: "Estuaire" },
          { name: "Haut-Ogooué" },
          { name: "Moyen-Ogooué" },
          { name: "Ngounié" },
          { name: "Nyanga" },
          { name: "Ogooué-Ivindo" },
          { name: "Ogooué-Lolo" },
          { name: "Ogooué-Maritime" },
          { name: "Woleu-Ntem" }
        ]
      },
      {
        country: "Gambia",
        code: "+220",
        states: [
          { name: "Banjul" },
          { name: "Central River" },
          { name: "Lower River" },
          { name: "North Bank" },
          { name: "Upper River" },
          { name: "Western" }
        ]
      },
      {
        country: "Georgia",
        code: "+995",
        states: [
          { name: "Adjara" },
          { name: "Guria" },
          { name: "Imereti" },
          { name: "Kakheti" },
          { name: "Kvemo Kartli" },
          { name: "Mtskheta-Mtianeti" },
          { name: "Racha-Lechkhumi and Kvemo Svaneti" },
          { name: "Samegrelo-Zemo Svaneti" },
          { name: "Samtskhe-Javakheti" },
          { name: "Shida Kartli" },
          { name: "Tbilisi" }
        ]
      },
      {
        country: "Germany",
        code: "+49",
        states: [
          { name: "Baden-Württemberg" },
          { name: "Bavaria" },
          { name: "Berlin" },
          { name: "Brandenburg" },
          { name: "Bremen" },
          { name: "Hamburg" },
          { name: "Hesse" },
          { name: "Lower Saxony" },
          { name: "Mecklenburg-Vorpommern" },
          { name: "North Rhine-Westphalia" },
          { name: "Rhineland-Palatinate" },
          { name: "Saarland" },
          { name: "Saxony" },
          { name: "Saxony-Anhalt" },
          { name: "Schleswig-Holstein" },
          { name: "Thuringia" }
        ]
      },
      {
        country: "Ghana",
        code: "+233",
        states: [
          { name: "Ahafo" },
          { name: "Ashanti" },
          { name: "Bono" },
          { name: "Bono East" },
          { name: "Central" },
          { name: "Eastern" },
          { name: "Greater Accra" },
          { name: "North East" },
          { name: "Northern" },
          { name: "Oti" },
          { name: "Savannah" },
          { name: "Upper East" },
          { name: "Upper West" },
          { name: "Volta" },
          { name: "Western" },
          { name: "Western North" }
        ]
      },
      {
        country: "Gibraltar",
        code: "+350",
        states: [
          { name: "No administrative divisions" }
        ]
      },
      {
        country: "Greece",
        code: "+30",
        states: [
          { name: "Attica" },
          { name: "Central Greece" },
          { name: "Central Macedonia" },
          { name: "Crete" },
          { name: "East Macedonia and Thrace" },
          { name: "Epirus" },
          { name: "Ionian Islands" },
          { name: "North Aegean" },
          { name: "Peloponnese" },
          { name: "South Aegean" },
          { name: "Thessaly" },
          { name: "West Greece" },
          { name: "West Macedonia" }
        ]
      },
      {
        country: "Greenland",
        code: "+299",
        states: [
          { name: "Kujalleq" },
          { name: "Qeqertalik" },
          { name: "Qeqqata" },
          { name: "Sermersooq" },
          { name: "Avannaata" }
        ]
      },
      {
        country: "Grenada",
        code: "+1473",
        states: [
          { name: "Carriacou and Petite Martinique" },
          { name: "Saint Andrew" },
          { name: "Saint David" },
          { name: "Saint George" },
          { name: "Saint John" },
          { name: "Saint Mark" },
          { name: "Saint Patrick" }
        ]
      },
      {
        country: "Guadeloupe",
        code: "+590",
        states: [
          { name: "Basse-Terre" },
          { name: "Pointe-à-Pitre" }
        ]
      },
      {
        country: "Guam",
        code: "+1671",
        states: [
          { name: "Agana Heights" },
          { name: "Agat" },
          { name: "Asan-Maina" },
          { name: "Barrigada" },
          { name: "Chalan Pago-Ordot" },
          { name: "Dededo" },
          { name: "Hagatna" },
          { name: "Inarajan" },
          { name: "Mangilao" },
          { name: "Merizo" },
          { name: "Mongmong-Toto-Maite" },
          { name: "Piti" },
          { name: "Santa Rita" },
          { name: "Sinajana" },
          { name: "Talofofo" },
          { name: "Tamuning-Tumon-Harmon" },
          { name: "Umatac" },
          { name: "Yigo" },
          { name: "Yona" }
        ]
      },
      {
        country: "Guatemala",
        code: "+502",
        states: [
          { name: "Alta Verapaz" },
          { name: "Baja Verapaz" },
          { name: "Chimaltenango" },
          { name: "Chiquimula" },
          { name: "El Progreso" },
          { name: "Escuintla" },
          { name: "Guatemala" },
          { name: "Huehuetenango" },
          { name: "Izabal" },
          { name: "Jalapa" },
          { name: "Jutiapa" },
          { name: "Petén" },
          { name: "Quetzaltenango" },
          { name: "Quiché" },
          { name: "Retalhuleu" },
          { name: "Sacatepéquez" },
          { name: "San Marcos" },
          { name: "Santa Rosa" },
          { name: "Sololá" },
          { name: "Suchitepéquez" },
          { name: "Totonicapán" },
          { name: "Zacapa" }
        ]
      },
      {
        country: "Guernsey",
        code: "+44",
        states: [
          { name: "Castel" },
          { name: "Forest" },
          { name: "St Andrew" },
          { name: "St Martin" },
          { name: "St Peter Port" },
          { name: "St Pierre du Bois" },
          { name: "St Sampson" },
          { name: "St Saviour" },
          { name: "Torteval" },
          { name: "Vale" }
        ]
      },
      {
        country: "Guinea",
        code: "+224",
        states: [
          { name: "Boké" },
          { name: "Conakry" },
          { name: "Faranah" },
          { name: "Kankan" },
          { name: "Kindia" },
          { name: "Labé" },
          { name: "Mamou" },
          { name: "Nzérékoré" }
        ]
      },
      {
        country: "Guinea-Bissau",
        code: "+245",
        states: [
          { name: "Bafatá" },
          { name: "Biombo" },
          { name: "Bolama" },
          { name: "Cacheu" },
          { name: "Gabu" },
          { name: "Oio" },
          { name: "Quinara" },
          { name: "Tombali" },
          { name: "Bissau" }
        ]
      },
      {
        country: "Guyana",
        code: "+592",
        states: [
          { name: "Barima-Waini" },
          { name: "Cuyuni-Mazaruni" },
          { name: "Demerara-Mahaica" },
          { name: "East Berbice-Corentyne" },
          { name: "Essequibo Islands-West Demerara" },
          { name: "Mahaica-Berbice" },
          { name: "Pomeroon-Supenaam" },
          { name: "Potaro-Siparuni" },
          { name: "Upper Demerara-Berbice" },
          { name: "Upper Takutu-Upper Essequibo" }
        ]
      },
      {
        country: "Haiti",
        code: "+509",
        states: [
          { name: "Artibonite" },
          { name: "Centre" },
          { name: "Grand'Anse" },
          { name: "Nippes" },
          { name: "Nord" },
          { name: "Nord-Est" },
          { name: "Nord-Ouest" },
          { name: "Ouest" },
          { name: "Sud" },
          { name: "Sud-Est" }
        ]
      },
      {
        country: "Heard Island and McDonald Islands",
        code: "+672",
        states: [
          { name: "No permanent administrative divisions" }
        ]
      },
      {
        country: "Vatican City",
        code: "+379",
        states: [
          { name: "Vatican City State" }
        ]
      },
      {
        country: "Honduras",
        code: "+504",
        states: [
          { name: "Atlántida" },
          { name: "Choluteca" },
          { name: "Colón" },
          { name: "Comayagua" },
          { name: "Copán" },
          { name: "Cortés" },
          { name: "El Paraíso" },
          { name: "Francisco Morazán" },
          { name: "Gracias a Dios" },
          { name: "Intibucá" },
          { name: "Islas de la Bahía" },
          { name: "La Paz" },
          { name: "Lempira" },
          { name: "Ocotepeque" },
          { name: "Olancho" },
          { name: "Santa Bárbara" },
          { name: "Valle" },
          { name: "Yoro" }
        ]
      },
      {
        country: "Hong Kong",
        code: "+852",
        states: [
          { name: "Hong Kong Island" },
          { name: "Kowloon" },
          { name: "New Territories" }
        ]
      },
      {
        country: "Hungary",
        code: "+36",
        states: [
          { name: "Bács-Kiskun" },
          { name: "Baranya" },
          { name: "Békés" },
          { name: "Borsod-Abaúj-Zemplén" },
          { name: "Budapest" },
          { name: "Csongrád-Csanád" },
          { name: "Fejér" },
          { name: "Győr-Moson-Sopron" },
          { name: "Hajdú-Bihar" },
          { name: "Heves" },
          { name: "Jász-Nagykun-Szolnok" },
          { name: "Komárom-Esztergom" },
          { name: "Nógrád" },
          { name: "Pest" },
          { name: "Somogy" },
          { name: "Szabolcs-Szatmár-Bereg" },
          { name: "Tolna" },
          { name: "Vas" },
          { name: "Veszprém" },
          { name: "Zala" }
        ]
      },
      {
        country: "Iceland",
        code: "+354",
        states: [
          { name: "Capital Region" },
          { name: "Southern Peninsula" },
          { name: "Western Region" },
          { name: "Westfjords" },
          { name: "Northwestern Region" },
          { name: "Northeastern Region" },
          { name: "Eastern Region" },
          { name: "Southern Region" }
        ]
      },
      {
        country: "India",
        code: "+91",
        states: [
          { name: "Andhra Pradesh" },
          { name: "Arunachal Pradesh" },
          { name: "Assam" },
          { name: "Bihar" },
          { name: "Chhattisgarh" },
          { name: "Goa" },
          { name: "Gujarat" },
          { name: "Haryana" },
          { name: "Himachal Pradesh" },
          { name: "Jharkhand" },
          { name: "Karnataka" },
          { name: "Kerala" },
          { name: "Madhya Pradesh" },
          { name: "Maharashtra" },
          { name: "Manipur" },
          { name: "Meghalaya" },
          { name: "Mizoram" },
          { name: "Nagaland" },
          { name: "Odisha" },
          { name: "Punjab" },
          { name: "Rajasthan" },
          { name: "Sikkim" },
          { name: "Tamil Nadu" },
          { name: "Telangana" },
          { name: "Tripura" },
          { name: "Uttar Pradesh" },
          { name: "Uttarakhand" },
          { name: "West Bengal" },
          { name: "Andaman and Nicobar Islands" },
          { name: "Chandigarh" },
          { name: "Dadra and Nagar Haveli and Daman and Diu" },
          { name: "Delhi" },
          { name: "Jammu and Kashmir" },
          { name: "Ladakh" },
          { name: "Lakshadweep" },
          { name: "Puducherry" }
        ]
      },
      {
        country: "Indonesia",
        code: "+62",
        states: [
          { name: "Aceh" },
          { name: "Bali" },
          { name: "Banten" },
          { name: "Bengkulu" },
          { name: "Central Java" },
          { name: "Central Kalimantan" },
          { name: "Central Sulawesi" },
          { name: "East Java" },
          { name: "East Kalimantan" },
          { name: "East Nusa Tenggara" },
          { name: "Gorontalo" },
          { name: "Jakarta" },
          { name: "Jambi" },
          { name: "Lampung" },
          { name: "Maluku" },
          { name: "North Kalimantan" },
          { name: "North Maluku" },
          { name: "North Sulawesi" },
          { name: "North Sumatra" },
          { name: "Papua" },
          { name: "Riau" },
          { name: "Riau Islands" },
          { name: "South Kalimantan" },
          { name: "South Sulawesi" },
          { name: "South Sumatra" },
          { name: "Southeast Sulawesi" },
          { name: "West Java" },
          { name: "West Kalimantan" },
          { name: "West Nusa Tenggara" },
          { name: "West Papua" },
          { name: "West Sulawesi" },
          { name: "West Sumatra" },
          { name: "Yogyakarta" }
        ]
      },
      {
        country: "Iran",
        code: "+98",
        states: [
          { name: "Alborz" },
          { name: "Ardabil" },
          { name: "Bushehr" },
          { name: "Chaharmahal and Bakhtiari" },
          { name: "East Azerbaijan" },
          { name: "Fars" },
          { name: "Gilan" },
          { name: "Golestan" },
          { name: "Hamadan" },
          { name: "Hormozgan" },
          { name: "Ilam" },
          { name: "Isfahan" },
          { name: "Kerman" },
          { name: "Kermanshah" },
          { name: "Khuzestan" },
          { name: "Kohgiluyeh and Boyer-Ahmad" },
          { name: "Kurdistan" },
          { name: "Lorestan" },
          { name: "Markazi" },
          { name: "Mazandaran" },
          { name: "North Khorasan" },
          { name: "Qazvin" },
          { name: "Qom" },
          { name: "Razavi Khorasan" },
          { name: "Semnan" },
          { name: "Sistan and Baluchestan" },
          { name: "South Khorasan" },
          { name: "Tehran" },
          { name: "West Azerbaijan" },
          { name: "Yazd" },
          { name: "Zanjan" }
        ]
      },
      {
        country: "Iraq",
        code: "+964",
        states: [
          { name: "Al Anbar" },
          { name: "Al Muthanna" },
          { name: "Al Qadisiyyah" },
          { name: "Babil" },
          { name: "Baghdad" },
          { name: "Basra" },
          { name: "Dhi Qar" },
          { name: "Diyala" },
          { name: "Dohuk" },
          { name: "Erbil" },
          { name: "Karbala" },
          { name: "Kirkuk" },
          { name: "Maysan" },
          { name: "Najaf" },
          { name: "Nineveh" },
          { name: "Saladin" },
          { name: "Sulaymaniyah" },
          { name: "Wasit" }
        ]
      },
      {
        country: "Ireland",
        code: "+353",
        states: [
          { name: "Carlow" },
          { name: "Cavan" },
          { name: "Clare" },
          { name: "Cork" },
          { name: "Donegal" },
          { name: "Dublin" },
          { name: "Galway" },
          { name: "Kerry" },
          { name: "Kildare" },
          { name: "Kilkenny" },
          { name: "Laois" },
          { name: "Leitrim" },
          { name: "Limerick" },
          { name: "Longford" },
          { name: "Louth" },
          { name: "Mayo" },
          { name: "Meath" },
          { name: "Monaghan" },
          { name: "Offaly" },
          { name: "Roscommon" },
          { name: "Sligo" },
          { name: "Tipperary" },
          { name: "Waterford" },
          { name: "Westmeath" },
          { name: "Wexford" },
          { name: "Wicklow" }
        ]
      },
      {
        country: "Isle of Man",
        code: "+44",
        states: [
          { name: "Ayre" },
          { name: "Garff" },
          { name: "Glenfaba and Peel" },
          { name: "Michael" },
          { name: "Middle" },
          { name: "Onchan" },
          { name: "Rushen" }
        ]
      },
      {
        country: "Israel",
        code: "+972",
        states: [
          { name: "Central" },
          { name: "Haifa" },
          { name: "Jerusalem" },
          { name: "Northern" },
          { name: "Southern" },
          { name: "Tel Aviv" }
        ]
      },
      {
        country: "Italy",
        code: "+39",
        states: [
          { name: "Abruzzo" },
          { name: "Aosta Valley" },
          { name: "Apulia" },
          { name: "Basilicata" },
          { name: "Calabria" },
          { name: "Campania" },
          { name: "Emilia-Romagna" },
          { name: "Friuli Venezia Giulia" },
          { name: "Lazio" },
          { name: "Liguria" },
          { name: "Lombardy" },
          { name: "Marche" },
          { name: "Molise" },
          { name: "Piedmont" },
          { name: "Sardinia" },
          { name: "Sicily" },
          { name: "Tuscany" },
          { name: "Trentino-Alto Adige/Südtirol" },
          { name: "Umbria" },
          { name: "Veneto" }
        ]
      },
      {
        country: "Jamaica",
        code: "+1876",
        states: [
          { name: "Clarendon" },
          { name: "Hanover" },
          { name: "Kingston" },
          { name: "Manchester" },
          { name: "Portland" },
          { name: "Saint Andrew" },
          { name: "Saint Ann" },
          { name: "Saint Catherine" },
          { name: "Saint Elizabeth" },
          { name: "Saint James" },
          { name: "Saint Mary" },
          { name: "Saint Thomas" },
          { name: "Trelawny" },
          { name: "Westmoreland" }
        ]
      },
      {
        country: "Japan",
        code: "+81",
        states: [
          { name: "Aichi" },
          { name: "Akita" },
          { name: "Aomori" },
          { name: "Chiba" },
          { name: "Ehime" },
          { name: "Fukui" },
          { name: "Fukuoka" },
          { name: "Fukushima" },
          { name: "Gifu" },
          { name: "Gunma" },
          { name: "Hiroshima" },
          { name: "Hokkaido" },
          { name: "Hyogo" },
          { name: "Ibaraki" },
          { name: "Ishikawa" },
          { name: "Iwate" },
          { name: "Kagawa" },
          { name: "Kagoshima" },
          { name: "Kanagawa" },
          { name: "Kochi" },
          { name: "Kumamoto" },
          { name: "Kyoto" },
          { name: "Mie" },
          { name: "Miyagi" },
          { name: "Miyazaki" },
          { name: "Nagano" },
          { name: "Nagasaki" },
          { name: "Nara" },
          { name: "Niigata" },
          { name: "Oita" },
          { name: "Okayama" },
          { name: "Okinawa" },
          { name: "Osaka" },
          { name: "Saga" },
          { name: "Saitama" },
          { name: "Shiga" },
          { name: "Shimane" },
          { name: "Shizuoka" },
          { name: "Tochigi" },
          { name: "Tokushima" },
          { name: "Tokyo" },
          { name: "Tottori" },
          { name: "Toyama" },
          { name: "Wakayama" },
          { name: "Yamagata" },
          { name: "Yamaguchi" },
          { name: "Yamanashi" }
        ]
      },
      {
        country: "Jersey",
        code: "+44",
        states: [
          { name: "Grouville" },
          { name: "Saint Brélade" },
          { name: "Saint Clement" },
          { name: "Saint Helier" },
          { name: "Saint John" },
          { name: "Saint Lawrence" },
          { name: "Saint Martin" },
          { name: "Saint Mary" },
          { name: "Saint Ouen" },
          { name: "Saint Peter" },
          { name: "Saint Saviour" },
          { name: "Trinity" }
        ]
      },
      {
        country: "Jordan",
        code: "+962",
        states: [
          { name: "Ajloun" },
          { name: "Amman" },
          { name: "Aqaba" },
          { name: "Balqa" },
          { name: "Irbid" },
          { name: "Jerash" },
          { name: "Karak" },
          { name: "Ma'an" },
          { name: "Madaba" },
          { name: "Mafraq" },
          { name: "Tafilah" },
          { name: "Zarqa" }
        ]
      },
      {
        country: "Kazakhstan",
        code: "+77",
        states: [
          { name: "Akmola" },
          { name: "Aktobe" },
          { name: "Almaty" },
          { name: "Atyrau" },
          { name: "East Kazakhstan" },
          { name: "Jambyl" },
          { name: "Karaganda" },
          { name: "Kostanay" },
          { name: "Kyzylorda" },
          { name: "Mangystau" },
          { name: "North Kazakhstan" },
          { name: "Pavlodar" },
          { name: "Turkistan" },
          { name: "West Kazakhstan" },
          { name: "Zhetysu" },
          { name: "Abai" },
          { name: "Ulytau" }
        ]
      },
      {
        country: "Kenya",
        code: "+254",
        states: [
          { name: "Baringo" },
          { name: "Bomet" },
          { name: "Bungoma" },
          { name: "Busia" },
          { name: "Elgeyo-Marakwet" },
          { name: "Embu" },
          { name: "Garissa" },
          { name: "Homa Bay" },
          { name: "Isiolo" },
          { name: "Kajiado" },
          { name: "Kakamega" },
          { name: "Kericho" },
          { name: "Kiambu" },
          { name: "Kilifi" },
          { name: "Kirinyaga" },
          { name: "Kisii" },
          { name: "Kisumu" },
          { name: "Kitui" },
          { name: "Kwale" },
          { name: "Laikipia" },
          { name: "Lamu" },
          { name: "Machakos" },
          { name: "Makueni" },
          { name: "Mandera" },
          { name: "Marsabit" },
          { name: "Meru" },
          { name: "Migori" },
          { name: "Mombasa" },
          { name: "Murang'a" },
          { name: "Nairobi" },
          { name: "Nakuru" },
          { name: "Nandi" },
          { name: "Narok" },
          { name: "Nyamira" },
          { name: "Nyandarua" },
          { name: "Nyeri" },
          { name: "Samburu" },
          { name: "Siaya" },
          { name: "Taita-Taveta" },
          { name: "Tana River" },
          { name: "Tharaka-Nithi" },
          { name: "Trans Nzoia" },
          { name: "Turkana" },
          { name: "Uasin Gishu" },
          { name: "Vihiga" },
          { name: "Wajir" },
          { name: "West Pokot" }
        ]
      },
      {
        country: "Kiribati",
        code: "+686",
        states: [
          { name: "Gilbert Islands" },
          { name: "Line Islands" },
          { name: "Phoenix Islands" }
        ]
      },
      {
        country: "North Korea",
        code: "+850",
        states: [
          { name: "Chagang" },
          { name: "North Hamgyong" },
          { name: "South Hamgyong" },
          { name: "North Hwanghae" },
          { name: "South Hwanghae" },
          { name: "Kangwon" },
          { name: "North Pyongan" },
          { name: "South Pyongan" },
          { name: "Ryanggang" },
          { name: "Pyongyang" },
          { name: "Rason" },
          { name: "Nampo" }
        ]
      },
      {
        country: "South Korea",
        code: "+82",
        states: [
          { name: "Busan" },
          { name: "Daegu" },
          { name: "Daejeon" },
          { name: "Gangwon" },
          { name: "Gwangju" },
          { name: "Gyeonggi" },
          { name: "Incheon" },
          { name: "Jeju" },
          { name: "North Chungcheong" },
          { name: "North Gyeongsang" },
          { name: "North Jeolla" },
          { name: "Sejong" },
          { name: "Seoul" },
          { name: "South Chungcheong" },
          { name: "South Gyeongsang" },
          { name: "South Jeolla" },
          { name: "Ulsan" }
        ]
      },
      {
        country: "Kosovo",
        code: "+383",
        states: [
          { name: "Ferizaj" },
          { name: "Gjakova" },
          { name: "Gjilan" },
          { name: "Mitrovica" },
          { name: "Peja" },
          { name: "Pristina" },
          { name: "Prizren" }
        ]
      },
      {
        country: "Kuwait",
        code: "+965",
        states: [
          { name: "Al Asimah" },
          { name: "Hawalli" },
          { name: "Farwaniya" },
          { name: "Mubarak Al-Kabeer" },
          { name: "Ahmadi" },
          { name: "Jahra" }
        ]
      },
      {
        country: "Kyrgyzstan",
        code: "+996",
        states: [
          { name: "Batken" },
          { name: "Chuy" },
          { name: "Jalal-Abad" },
          { name: "Naryn" },
          { name: "Osh" },
          { name: "Talas" },
          { name: "Issyk-Kul" },
          { name: "Bishkek" }
        ]
      },
      {
        country: "Laos",
        code: "+856",
        states: [
          { name: "Attapeu" },
          { name: "Bokeo" },
          { name: "Bolikhamsai" },
          { name: "Champasak" },
          { name: "Houaphanh" },
          { name: "Khammouane" },
          { name: "Luang Namtha" },
          { name: "Luang Prabang" },
          { name: "Oudomxay" },
          { name: "Phongsaly" },
          { name: "Salavan" },
          { name: "Savannakhet" },
          { name: "Sekong" },
          { name: "Vientiane" },
          { name: "Vientiane Prefecture" },
          { name: "Xaisomboun" },
          { name: "Xayaburi" },
          { name: "Xieng Khouang" }
        ]
      },
      {
        country: "Latvia",
        code: "+371",
        states: [
          { name: "Kurzeme" },
          { name: "Latgale" },
          { name: "Riga" },
          { name: "Vidzeme" },
          { name: "Zemgale" }
        ]
      },
      {
        country: "Lebanon",
        code: "+961",
        states: [
          { name: "Akkar" },
          { name: "Baalbek-Hermel" },
          { name: "Beirut" },
          { name: "Beqaa" },
          { name: "Mount Lebanon" },
          { name: "Nabatieh" },
          { name: "North" },
          { name: "South" }
        ]
      },
      {
        country: "Lesotho",
        code: "+266",
        states: [
          { name: "Berea" },
          { name: "Butha-Buthe" },
          { name: "Leribe" },
          { name: "Mafeteng" },
          { name: "Maseru" },
          { name: "Mohale's Hoek" },
          { name: "Mokhotlong" },
          { name: "Qacha's Nek" },
          { name: "Quthing" },
          { name: "Thaba-Tseka" }
        ]
      },
      {
        country: "Liberia",
        code: "+231",
        states: [
          { name: "Bomi" },
          { name: "Bong" },
          { name: "Gbarpolu" },
          { name: "Grand Bassa" },
          { name: "Grand Cape Mount" },
          { name: "Grand Gedeh" },
          { name: "Grand Kru" },
          { name: "Lofa" },
          { name: "Margibi" },
          { name: "Maryland" },
          { name: "Montserrado" },
          { name: "Nimba" },
          { name: "River Cess" },
          { name: "River Gee" },
          { name: "Sinoe" }
        ]
      },
      {
        country: "Libya",
        code: "+218",
        states: [
          { name: "Tripoli" },
          { name: "Benghazi" },
          { name: "Misrata" },
          { name: "Al Jabal al Akhdar" },
          { name: "Al Jufra" },
          { name: "Al Kufra" },
          { name: "Al Marj" },
          { name: "Al Murqub" },
          { name: "Al Wahat" },
          { name: "Nalut" },
          { name: "Sebha" },
          { name: "Sirte" },
          { name: "Wadi al Hayaa" },
          { name: "Wadi ash Shati" },
          { name: "Zawiya" }
        ]
      },
      {
        country: "Liechtenstein",
        code: "+423",
        states: [
          { name: "Balzers" },
          { name: "Eschen" },
          { name: "Gamprin" },
          { name: "Mauren" },
          { name: "Planken" },
          { name: "Ruggell" },
          { name: "Schaan" },
          { name: "Schellenberg" },
          { name: "Triesen" },
          { name: "Triesenberg" },
          { name: "Vaduz" }
        ]
      },
      {
        country: "Lithuania",
        code: "+370",
        states: [
          { name: "Alytus" },
          { name: "Kaunas" },
          { name: "Klaipėda" },
          { name: "Marijampolė" },
          { name: "Panevėžys" },
          { name: "Šiauliai" },
          { name: "Tauragė" },
          { name: "Telšiai" },
          { name: "Utena" },
          { name: "Vilnius" }
        ]
      },
      {
        country: "Luxembourg",
        code: "+352",
        states: [
          { name: "Capellen" },
          { name: "Clervaux" },
          { name: "Diekirch" },
          { name: "Echternach" },
          { name: "Esch-sur-Alzette" },
          { name: "Grevenmacher" },
          { name: "Luxembourg" },
          { name: "Mersch" },
          { name: "Redange" },
          { name: "Remich" },
          { name: "Vianden" },
          { name: "Wiltz" }
        ]
      },
      {
        country: "Macao",
        code: "+853",
        states: [
          { name: "Nossa Senhora de Fátima" },
          { name: "Santo António" },
          { name: "São Lázaro" },
          { name: "São Lourenço" },
          { name: "Sé" },
          { name: "Cotai" },
          { name: "Taipa" },
          { name: "Coloane" }
        ]
      },
      {
        country: "Macedonia",
        code: "+389",
        states: [
          { name: "Aerodrom" },
          { name: "Bitola" },
          { name: "Gostivar" },
          { name: "Kavadarci" },
          { name: "Kičevo" },
          { name: "Kumanovo" },
          { name: "Ohrid" },
          { name: "Prilep" },
          { name: "Skopje" },
          { name: "Struga" },
          { name: "Tetovo" },
          { name: "Veles" }
        ]
      },
      {
        country: "Madagascar",
        code: "+261",
        states: [
          { name: "Antananarivo" },
          { name: "Antsiranana" },
          { name: "Fianarantsoa" },
          { name: "Mahajanga" },
          { name: "Toamasina" },
          { name: "Toliara" }
        ]
      },
      {
        country: "Malawi",
        code: "+265",
        states: [
          { name: "Central" },
          { name: "Northern" },
          { name: "Southern" }
        ]
      },
      {
        country: "Malaysia",
        code: "+60",
        states: [
          { name: "Johor" },
          { name: "Kedah" },
          { name: "Kelantan" },
          { name: "Malacca" },
          { name: "Negeri Sembilan" },
          { name: "Pahang" },
          { name: "Penang" },
          { name: "Perak" },
          { name: "Perlis" },
          { name: "Sabah" },
          { name: "Sarawak" },
          { name: "Selangor" },
          { name: "Terengganu" },
          { name: "Kuala Lumpur" },
          { name: "Labuan" },
          { name: "Putrajaya" }
        ]
      },
      {
        country: "Maldives",
        code: "+960",
        states: [
          { name: "Alif Alif" },
          { name: "Alif Dhaal" },
          { name: "Baa" },
          { name: "Dhaalu" },
          { name: "Faafu" },
          { name: "Gaafu Alif" },
          { name: "Gaafu Dhaalu" },
          { name: "Gnaviyani" },
          { name: "Haa Alif" },
          { name: "Haa Dhaalu" },
          { name: "Kaafu" },
          { name: "Laamu" },
          { name: "Lhaviyani" },
          { name: "Meemu" },
          { name: "Noonu" },
          { name: "Raa" },
          { name: "Seenu" },
          { name: "Shaviyani" },
          { name: "Thaa" },
          { name: "Vaavu" }
        ]
      },
      {
        country: "Mali",
        code: "+223",
        states: [
          { name: "Bamako" },
          { name: "Gao" },
          { name: "Kayes" },
          { name: "Kidal" },
          { name: "Koulikoro" },
          { name: "Mopti" },
          { name: "Segou" },
          { name: "Sikasso" },
          { name: "Tombouctou" }
        ]
      },
      {
        country: "Malta",
        code: "+356",
        states: [
          { name: "Attard" },
          { name: "Balzan" },
          { name: "Birgu" },
          { name: "Birkirkara" },
          { name: "Birzebbuga" },
          { name: "Cospicua" },
          { name: "Dingli" },
          { name: "Fgura" },
          { name: "Floriana" },
          { name: "Fontana" },
          { name: "Gzira" },
          { name: "Hamrun" },
          { name: "Marsa" },
          { name: "Mdina" },
          { name: "Mellieha" },
          { name: "Mgarr" },
          { name: "Mosta" },
          { name: "Msida" },
          { name: "Nadur" },
          { name: "Naxxar" },
          { name: "Paola" },
          { name: "Pembroke" },
          { name: "Qormi" },
          { name: "Rabat" },
          { name: "Safi" },
          { name: "Sliema" },
          { name: "Valletta" },
          { name: "Victoria" },
          { name: "Xaghra" },
          { name: "Zebbug" },
          { name: "Zejtun" }
        ]
      },
      {
        country: "Marshall Islands",
        code: "+692",
        states: [
          { name: "Ailinglaplap" },
          { name: "Ailuk" },
          { name: "Arno" },
          { name: "Aur" },
          { name: "Ebon" },
          { name: "Eniwetok" },
          { name: "Jabat" },
          { name: "Jaluit" },
          { name: "Kili" },
          { name: "Kwajalein" },
          { name: "Lae" },
          { name: "Lib" },
          { name: "Likiep" },
          { name: "Majuro" },
          { name: "Maloelap" },
          { name: "Mejit" },
          { name: "Mili" },
          { name: "Namorik" },
          { name: "Namu" },
          { name: "Rongelap" },
          { name: "Ujae" },
          { name: "Utrik" },
          { name: "Wotho" },
          { name: "Wotje" }
        ]
      },
      {
        country: "Martinique",
        code: "+596",
        states: [
          { name: "Fort-de-France" },
          { name: "Le Marin" },
          { name: "La Trinité" },
          { name: "Saint-Pierre" }
        ]
      },
      {
        country: "Mauritania",
        code: "+222",
        states: [
          { name: "Adrar" },
          { name: "Assaba" },
          { name: "Brakna" },
          { name: "Dakhlet Nouadhibou" },
          { name: "Gorgol" },
          { name: "Guidimaka" },
          { name: "Hodh Ech Chargui" },
          { name: "Hodh El Gharbi" },
          { name: "Inchiri" },
          { name: "Nouakchott-Nord" },
          { name: "Nouakchott-Ouest" },
          { name: "Nouakchott-Sud" },
          { name: "Tagant" },
          { name: "Tiris Zemmour" },
          { name: "Trarza" }
        ]
      },
      {
        country: "Mauritius",
        code: "+230",
        states: [
          { name: "Black River" },
          { name: "Flacq" },
          { name: "Grand Port" },
          { name: "Moka" },
          { name: "Pamplemousses" },
          { name: "Plaines Wilhems" },
          { name: "Port Louis" },
          { name: "Rivière du Rempart" },
          { name: "Savanne" },
          { name: "Rodrigues" }
        ]
      },
      {
        country: "Mayotte",
        code: "+262",
        states: [
          { name: "Dzaoudzi" },
          { name: "Mamoudzou" },
          { name: "Koungou" },
          { name: "Chirongui" },
          { name: "Bouéni" },
          { name: "Tsingoni" },
          { name: "Sada" },
          { name: "Bandrélé" },
          { name: "Acoua" },
          { name: "Mtsamboro" }
        ]
      },
      {
        country: "Mexico",
        code: "+52",
        states: [
          { name: "Aguascalientes" },
          { name: "Baja California" },
          { name: "Baja California Sur" },
          { name: "Campeche" },
          { name: "Chiapas" },
          { name: "Chihuahua" },
          { name: "Coahuila" },
          { name: "Colima" },
          { name: "Durango" },
          { name: "Guanajuato" },
          { name: "Guerrero" },
          { name: "Hidalgo" },
          { name: "Jalisco" },
          { name: "Mexico State" },
          { name: "Michoacán" },
          { name: "Morelos" },
          { name: "Nayarit" },
          { name: "Nuevo León" },
          { name: "Oaxaca" },
          { name: "Puebla" },
          { name: "Querétaro" },
          { name: "Quintana Roo" },
          { name: "San Luis Potosí" },
          { name: "Sinaloa" },
          { name: "Sonora" },
          { name: "Tabasco" },
          { name: "Tamaulipas" },
          { name: "Tlaxcala" },
          { name: "Veracruz" },
          { name: "Yucatán" },
          { name: "Zacatecas" },
          { name: "Mexico City" }
        ]
      },
      {
        country: "Micronesia",
        code: "+691",
        states: [
          { name: "Chuuk" },
          { name: "Kosrae" },
          { name: "Pohnpei" },
          { name: "Yap" }
        ]
      },
      {
        country: "Moldova",
        code: "+373",
        states: [
          { name: "Anenii Noi" },
          { name: "Basarabeasca" },
          { name: "Briceni" },
          { name: "Cahul" },
          { name: "Cantemir" },
          { name: "Călărași" },
          { name: "Căușeni" },
          { name: "Chișinău" },
          { name: "Edineț" },
          { name: "Florești" },
          { name: "Găgăuzia" },
          { name: "Hîncești" },
          { name: "Ialoveni" },
          { name: "Leova" },
          { name: "Nisporeni" },
          { name: "Orhei" },
          { name: "Soroca" },
          { name: "Strășeni" },
          { name: "Ștefan Vodă" },
          { name: "Taraclia" },
          { name: "Telenești" },
          { name: "Ungheni" }
        ]
      },
      {
        country: "Monaco",
        code: "+377",
        states: [
          { name: "La Condamine" },
          { name: "Monaco-Ville" },
          { name: "Monte Carlo" },
          { name: "Fontvieille" }
        ]
      },
      {
        country: "Mongolia",
        code: "+976",
        states: [
          { name: "Arkhangai" },
          { name: "Bayan-Ölgii" },
          { name: "Bayankhongor" },
          { name: "Bulgan" },
          { name: "Darkhan-Uul" },
          { name: "Dornod" },
          { name: "Dornogovi" },
          { name: "Dundgovi" },
          { name: "Govi-Altai" },
          { name: "Govisümber" },
          { name: "Khentii" },
          { name: "Khovd" },
          { name: "Khuvsgul" },
          { name: "Orkhon" },
          { name: "Ömnögovi" },
          { name: "Selenge" },
          { name: "Sükhbaatar" },
          { name: "Töv" },
          { name: "Uvs" },
          { name: "Zavkhan" },
          { name: "Ulaanbaatar" }
        ]
      },
      {
        country: "Montenegro",
        code: "+382",
        states: [
          { name: "Andrijevica" },
          { name: "Bar" },
          { name: "Berane" },
          { name: "Bijelo Polje" },
          { name: "Budva" },
          { name: "Cetinje" },
          { name: "Danilovgrad" },
          { name: "Herceg Novi" },
          { name: "Kolašin" },
          { name: "Kotor" },
          { name: "Mojkovac" },
          { name: "Nikšić" },
          { name: "Plav" },
          { name: "Pljevlja" },
          { name: "Podgorica" },
          { name: "Rožaje" },
          { name: "Tivat" },
          { name: "Ulcinj" },
          { name: "Žabljak" }
        ]
      },
      {
        country: "Montserrat",
        code: "+1664",
        states: [
          { name: "Saint Anthony" },
          { name: "Saint Georges" },
          { name: "Saint Peter" }
        ]
      },
      {
        country: "Morocco",
        code: "+212",
        states: [
          { name: "Casablanca-Settat" },
          { name: "Rabat-Salé-Kénitra" },
          { name: "Fès-Meknès" },
          { name: "Marrakech-Safi" },
          { name: "Tangier-Tétouan-Al Hoceïma" },
          { name: "Béni Mellal-Khénifra" },
          { name: "Oriental" },
          { name: "Souss-Massa" },
          { name: "Drâa-Tafilalet" },
          { name: "Guelmim-Oued Noun" },
          { name: "Laâyoune-Sakia El Hamra" },
          { name: "Dakhla-Oued Ed-Dahab" }
        ]
      },
      {
        country: "Mozambique",
        code: "+258",
        states: [
          { name: "Cabo Delgado" },
          { name: "Gaza" },
          { name: "Inhambane" },
          { name: "Manica" },
          { name: "Maputo" },
          { name: "Nampula" },
          { name: "Niassa" },
          { name: "Sofala" },
          { name: "Tete" },
          { name: "Zambezia" }
        ]
      },
      {
        country: "Myanmar",
        code: "+95",
        states: [
          { name: "Ayeyarwady" },
          { name: "Bago" },
          { name: "Chin" },
          { name: "Kachin" },
          { name: "Kayah" },
          { name: "Kayin" },
          { name: "Magway" },
          { name: "Mandalay" },
          { name: "Mon" },
          { name: "Naypyidaw" },
          { name: "Rakhine" },
          { name: "Sagaing" },
          { name: "Shan" },
          { name: "Tanintharyi" },
          { name: "Yangon" }
        ]
      },
      {
        country: "Namibia",
        code: "+264",
        states: [
          { name: "Erongo" },
          { name: "Hardap" },
          { name: "Karas" },
          { name: "Kavango East" },
          { name: "Kavango West" },
          { name: "Khomas" },
          { name: "Kunene" },
          { name: "Ohangwena" },
          { name: "Omaheke" },
          { name: "Omusati" },
          { name: "Oshana" },
          { name: "Oshikoto" },
          { name: "Otjozondjupa" },
          { name: "Zambezi" }
        ]
      },
      {
        country: "Nauru",
        code: "+674",
        states: [
          { name: "Aiwo" },
          { name: "Anabar" },
          { name: "Anetan" },
          { name: "Anibare" },
          { name: "Baiti" },
          { name: "Boe" },
          { name: "Buada" },
          { name: "Denigomodu" },
          { name: "Ewa" },
          { name: "Ijuw" },
          { name: "Meneng" },
          { name: "Nibok" },
          { name: "Uaboe" },
          { name: "Yaren" }
        ]
      },
      {
        country: "Nepal",
        code: "+977",
        states: [
          { name: "Koshi" },
          { name: "Madhesh" },
          { name: "Bagmati" },
          { name: "Gandaki" },
          { name: "Lumbini" },
          { name: "Karnali" },
          { name: "Sudurpashchim" }
        ]
      },
      {
        country: "Netherlands",
        code: "+31",
        states: [
          { name: "Drenthe" },
          { name: "Flevoland" },
          { name: "Friesland" },
          { name: "Gelderland" },
          { name: "Groningen" },
          { name: "Limburg" },
          { name: "North Brabant" },
          { name: "North Holland" },
          { name: "Overijssel" },
          { name: "South Holland" },
          { name: "Utrecht" },
          { name: "Zeeland" }
        ]
      },
      {
        country: "Netherlands Antilles",
        code: "+599",
        states: [
          { name: "Bonaire" },
          { name: "Curaçao" },
          { name: "Saba" },
          { name: "Sint Eustatius" },
          { name: "Sint Maarten" }
        ]
      },
      {
        country: "New Caledonia",
        code: "+687",
        states: [
          { name: "Loyalty Islands" },
          { name: "North Province" },
          { name: "South Province" }
        ]
      },
      {
        country: "New Zealand",
        code: "+64",
        states: [
          { name: "Auckland" },
          { name: "Bay of Plenty" },
          { name: "Canterbury" },
          { name: "Gisborne" },
          { name: "Hawke's Bay" },
          { name: "Manawatu-Wanganui" },
          { name: "Marlborough" },
          { name: "Nelson" },
          { name: "Northland" },
          { name: "Otago" },
          { name: "Southland" },
          { name: "Taranaki" },
          { name: "Tasman" },
          { name: "Waikato" },
          { name: "Wellington" },
          { name: "West Coast" }
        ]
      },
      {
        country: "Nicaragua",
        code: "+505",
        states: [
          { name: "Boaco" },
          { name: "Carazo" },
          { name: "Chinandega" },
          { name: "Chontales" },
          { name: "Estelí" },
          { name: "Granada" },
          { name: "Jinotega" },
          { name: "León" },
          { name: "Madriz" },
          { name: "Managua" },
          { name: "Masaya" },
          { name: "Matagalpa" },
          { name: "Nueva Segovia" },
          { name: "Río San Juan" },
          { name: "Rivas" },
          { name: "North Caribbean Coast" },
          { name: "South Caribbean Coast" }
        ]
      },
      {
        country: "Niger",
        code: "+227",
        states: [
          { name: "Agadez" },
          { name: "Diffa" },
          { name: "Dosso" },
          { name: "Maradi" },
          { name: "Tahoua" },
          { name: "Tillabéri" },
          { name: "Zinder" },
          { name: "Niamey" }
        ]
      },
      {
        country: "Nigeria",
        code: "+234",
        states: [
          { name: "Abia" },
          { name: "Adamawa" },
          { name: "Akwa Ibom" },
          { name: "Anambra" },
          { name: "Bauchi" },
          { name: "Bayelsa" },
          { name: "Benue" },
          { name: "Borno" },
          { name: "Cross River" },
          { name: "Delta" },
          { name: "Ebonyi" },
          { name: "Edo" },
          { name: "Ekiti" },
          { name: "Enugu" },
          { name: "Gombe" },
          { name: "Imo" },
          { name: "Jigawa" },
          { name: "Kaduna" },
          { name: "Kano" },
          { name: "Katsina" },
          { name: "Kebbi" },
          { name: "Kogi" },
          { name: "Kwara" },
          { name: "Lagos" },
          { name: "Nasarawa" },
          { name: "Niger" },
          { name: "Ogun" },
          { name: "Ondo" },
          { name: "Osun" },
          { name: "Oyo" },
          { name: "Plateau" },
          { name: "Rivers" },
          { name: "Sokoto" },
          { name: "Taraba" },
          { name: "Yobe" },
          { name: "Zamfara" },
          { name: "Federal Capital Territory" }
        ]
      },
      {
        country: "Niue",
        code: "+683",
        states: [
          { name: "Alofi North" },
          { name: "Alofi South" },
          { name: "Hakupu" },
          { name: "Lakepa" },
          { name: "Liku" },
          { name: "Makefu" },
          { name: "Mutalau" },
          { name: "Namukulu" },
          { name: "Tamake" },
          { name: "Tuapa" },
          { name: "Vaiea" }
        ]
      },
      {
        country: "Norfolk Island",
        code: "+672",
        states: [
          { name: "Kingston" },
          { name: "Burnt Pine" },
          { name: "Cascade" }
        ]
      },
      {
        country: "Northern Mariana Islands",
        code: "+1670",
        states: [
          { name: "Saipan" },
          { name: "Tinian" },
          { name: "Rota" },
          { name: "Northern Islands" }
        ]
      },
      {
        country: "Norway",
        code: "+47",
        states: [
          { name: "Agder" },
          { name: "Innlandet" },
          { name: "Møre og Romsdal" },
          { name: "Nordland" },
          { name: "Oslo" },
          { name: "Rogaland" },
          { name: "Troms og Finnmark" },
          { name: "Trøndelag" },
          { name: "Vestfold og Telemark" },
          { name: "Vestland" },
          { name: "Viken" }
        ]
      },
      {
        country: "Oman",
        code: "+968",
        states: [
          { name: "Ad Dakhiliyah" },
          { name: "Ad Dhahirah" },
          { name: "Al Batinah North" },
          { name: "Al Batinah South" },
          { name: "Al Buraymi" },
          { name: "Al Wusta" },
          { name: "Ash Sharqiyah North" },
          { name: "Ash Sharqiyah South" },
          { name: "Dhofar" },
          { name: "Musandam" },
          { name: "Muscat" }
        ]
      },
      {
        country: "Pakistan",
        code: "+92",
        states: [
          { name: "Azad Jammu and Kashmir" },
          { name: "Balochistan" },
          { name: "Gilgit-Baltistan" },
          { name: "Islamabad Capital Territory" },
          { name: "Khyber Pakhtunkhwa" },
          { name: "Punjab" },
          { name: "Sindh" }
        ]
      },
      {
        country: "Palau",
        code: "+680",
        states: [
          { name: "Aimeliik" },
          { name: "Airai" },
          { name: "Angaur" },
          { name: "Hatohobei" },
          { name: "Kayangel" },
          { name: "Koror" },
          { name: "Melekeok" },
          { name: "Ngaraard" },
          { name: "Ngarchelong" },
          { name: "Ngardmau" },
          { name: "Ngatpang" },
          { name: "Ngchesar" },
          { name: "Ngeremlengui" },
          { name: "Ngiwal" },
          { name: "Peleliu" },
          { name: "Sonsorol" }
        ]
      },
      {
        country: "Palestine",
        code: "+970",
        states: [
          { name: "Bethlehem" },
          { name: "Deir al-Balah" },
          { name: "Gaza" },
          { name: "Hebron" },
          { name: "Jenin" },
          { name: "Jericho and Al Aghwar" },
          { name: "Jerusalem" },
          { name: "Khan Yunis" },
          { name: "Nablus" },
          { name: "North Gaza" },
          { name: "Qalqilya" },
          { name: "Rafah" },
          { name: "Ramallah and Al-Bireh" },
          { name: "Salfit" },
          { name: "Tubas" },
          { name: "Tulkarm" }
        ]
      },
      {
        country: "Panama",
        code: "+507",
        states: [
          { name: "Bocas del Toro" },
          { name: "Chiriquí" },
          { name: "Coclé" },
          { name: "Colón" },
          { name: "Darién" },
          { name: "Herrera" },
          { name: "Los Santos" },
          { name: "Panamá" },
          { name: "Veraguas" },
          { name: "Panamá Oeste" },
          { name: "Emberá" },
          { name: "Guna Yala" },
          { name: "Ngäbe-Buglé" }
        ]
      },
      {
        country: "Papua New Guinea",
        code: "+675",
        states: [
          { name: "Central" },
          { name: "Chimbu" },
          { name: "East New Britain" },
          { name: "East Sepik" },
          { name: "Eastern Highlands" },
          { name: "Enga" },
          { name: "Gulf" },
          { name: "Hela" },
          { name: "Jiwaka" },
          { name: "Madang" },
          { name: "Manus" },
          { name: "Milne Bay" },
          { name: "Morobe" },
          { name: "New Ireland" },
          { name: "Northern" },
          { name: "Southern Highlands" },
          { name: "West New Britain" },
          { name: "West Sepik" },
          { name: "Western" },
          { name: "Western Highlands" },
          { name: "Autonomous Region of Bougainville" },
          { name: "National Capital District" }
        ]
      },
      {
        country: "Paraguay",
        code: "+595",
        states: [
          { name: "Alto Paraguay" },
          { name: "Alto Paraná" },
          { name: "Amambay" },
          { name: "Boquerón" },
          { name: "Caaguazú" },
          { name: "Caazapá" },
          { name: "Canindeyú" },
          { name: "Central" },
          { name: "Concepción" },
          { name: "Cordillera" },
          { name: "Guairá" },
          { name: "Itapúa" },
          { name: "Misiones" },
          { name: "Ñeembucú" },
          { name: "Paraguarí" },
          { name: "Presidente Hayes" },
          { name: "San Pedro" },
          { name: "Asunción" }
        ]
      },
      {
        country: "Peru",
        code: "+51",
        states: [
          { name: "Amazonas" },
          { name: "Áncash" },
          { name: "Apurímac" },
          { name: "Arequipa" },
          { name: "Ayacucho" },
          { name: "Cajamarca" },
          { name: "Callao" },
          { name: "Cusco" },
          { name: "Huancavelica" },
          { name: "Huánuco" },
          { name: "Ica" },
          { name: "Junín" },
          { name: "La Libertad" },
          { name: "Lambayeque" },
          { name: "Lima" },
          { name: "Loreto" },
          { name: "Madre de Dios" },
          { name: "Moquegua" },
          { name: "Pasco" },
          { name: "Piura" },
          { name: "Puno" },
          { name: "San Martín" },
          { name: "Tacna" },
          { name: "Tumbes" },
          { name: "Ucayali" }
        ]
      },
      {
        country: "Philippines",
        code: "+63",
        states: [
          { name: "Abra" },
          { name: "Agusan del Norte" },
          { name: "Agusan del Sur" },
          { name: "Aklan" },
          { name: "Albay" },
          { name: "Antique" },
          { name: "Apayao" },
          { name: "Aurora" },
          { name: "Basilan" },
          { name: "Bataan" },
          { name: "Batanes" },
          { name: "Batangas" },
          { name: "Benguet" },
          { name: "Biliran" },
          { name: "Bohol" },
          { name: "Bukidnon" },
          { name: "Bulacan" },
          { name: "Cagayan" },
          { name: "Camarines Norte" },
          { name: "Camarines Sur" },
          { name: "Camiguin" },
          { name: "Capiz" },
          { name: "Catanduanes" },
          { name: "Cavite" },
          { name: "Cebu" },
          { name: "Compostela Valley" },
          { name: "Cotabato" },
          { name: "Davao del Norte" },
          { name: "Davao del Sur" },
          { name: "Davao Occidental" },
          { name: "Davao Oriental" },
          { name: "Eastern Samar" },
          { name: "Guimaras" },
          { name: "Ifugao" },
          { name: "Ilocos Norte" },
          { name: "Ilocos Sur" },
          { name: "Iloilo" },
          { name: "Isabela" },
          { name: "Kalinga" },
          { name: "La Union" },
          { name: "Laguna" },
          { name: "Lanao del Norte" },
          { name: "Lanao del Sur" },
          { name: "Leyte" },
          { name: "Maguindanao" },
          { name: "Marinduque" },
          { name: "Masbate" },
          { name: "Misamis Occidental" },
          { name: "Misamis Oriental" },
          { name: "Mountain Province" },
          { name: "Negros Occidental" },
          { name: "Negros Oriental" },
          { name: "Northern Samar" },
          { name: "Nueva Ecija" },
          { name: "Nueva Vizcaya" },
          { name: "Occidental Mindoro" },
          { name: "Oriental Mindoro" },
          { name: "Palawan" },
          { name: "Pampanga" },
          { name: "Pangasinan" },
          { name: "Quezon" },
          { name: "Quirino" },
          { name: "Rizal" },
          { name: "Romblon" },
          { name: "Samar" },
          { name: "Sarangani" },
          { name: "Siquijor" },
          { name: "Sorsogon" },
          { name: "South Cotabato" },
          { name: "Southern Leyte" },
          { name: "Sultan Kudarat" },
          { name: "Sulu" },
          { name: "Surigao del Norte" },
          { name: "Surigao del Sur" },
          { name: "Tarlac" },
          { name: "Tawi-Tawi" },
          { name: "Zambales" },
          { name: "Zamboanga del Norte" },
          { name: "Zamboanga del Sur" },
          { name: "Zamboanga Sibugay" },
          { name: "Metro Manila" }
        ]
      },
      {
        country: "Pitcairn Islands",
        code: "+64",
        states: [
          { name: "Adamstown" }
        ]
      },
      {
        country: "Poland",
        code: "+48",
        states: [
          { name: "Greater Poland" },
          { name: "Kuyavian-Pomeranian" },
          { name: "Lesser Poland" },
          { name: "Lodz" },
          { name: "Lower Silesian" },
          { name: "Lublin" },
          { name: "Lubusz" },
          { name: "Masovian" },
          { name: "Opole" },
          { name: "Podlaskie" },
          { name: "Pomeranian" },
          { name: "Silesian" },
          { name: "Subcarpathian" },
          { name: "Swietokrzyskie" },
          { name: "Warmian-Masurian" },
          { name: "West Pomeranian" }
        ]
      },
      {
        country: "Portugal",
        code: "+351",
        states: [
          { name: "Aveiro" },
          { name: "Beja" },
          { name: "Braga" },
          { name: "Bragança" },
          { name: "Castelo Branco" },
          { name: "Coimbra" },
          { name: "Évora" },
          { name: "Faro" },
          { name: "Guarda" },
          { name: "Leiria" },
          { name: "Lisbon" },
          { name: "Portalegre" },
          { name: "Porto" },
          { name: "Santarém" },
          { name: "Setúbal" },
          { name: "Viana do Castelo" },
          { name: "Vila Real" },
          { name: "Viseu" },
          { name: "Azores" },
          { name: "Madeira" }
        ]
      },
      {
        country: "Puerto Rico",
        code: "+1939",
        states: [
          { name: "Adjuntas" },
          { name: "Aguada" },
          { name: "Aguadilla" },
          { name: "Aguas Buenas" },
          { name: "Aibonito" },
          { name: "Añasco" },
          { name: "Arecibo" },
          { name: "Arroyo" },
          { name: "Barceloneta" },
          { name: "Barranquitas" },
          { name: "Bayamón" },
          { name: "Cabo Rojo" },
          { name: "Caguas" },
          { name: "Camuy" },
          { name: "Canóvanas" },
          { name: "Carolina" },
          { name: "Cataño" },
          { name: "Cayey" },
          { name: "Ceiba" },
          { name: "Ciales" },
          { name: "Cidra" },
          { name: "Coamo" },
          { name: "Comerío" },
          { name: "Corozal" },
          { name: "Culebra" },
          { name: "Dorado" },
          { name: "Fajardo" },
          { name: "Florida" },
          { name: "Guánica" },
          { name: "Guayama" },
          { name: "Guayanilla" },
          { name: "Guaynabo" },
          { name: "Gurabo" },
          { name: "Hatillo" },
          { name: "Hormigueros" },
          { name: "Humacao" },
          { name: "Isabela" },
          { name: "Jayuya" },
          { name: "Juana Díaz" },
          { name: "Juncos" },
          { name: "Lajas" },
          { name: "Lares" },
          { name: "Las Marías" },
          { name: "Las Piedras" },
          { name: "Loíza" },
          { name: "Luquillo" },
          { name: "Manatí" },
          { name: "Maricao" },
          { name: "Maunabo" },
          { name: "Mayagüez" },
          { name: "Moca" },
          { name: "Morovis" },
          { name: "Naguabo" },
          { name: "Naranjito" },
          { name: "Orocovis" },
          { name: "Patillas" },
          { name: "Peñuelas" },
          { name: "Ponce" },
          { name: "Quebradillas" },
          { name: "Rincón" },
          { name: "Río Grande" },
          { name: "Sabana Grande" },
          { name: "Salinas" },
          { name: "San Germán" },
          { name: "San Juan" },
          { name: "San Lorenzo" },
          { name: "San Sebastián" },
          { name: "Santa Isabel" },
          { name: "Toa Alta" },
          { name: "Toa Baja" },
          { name: "Trujillo Alto" },
          { name: "Utuado" },
          { name: "Vega Alta" },
          { name: "Vega Baja" },
          { name: "Vieques" },
          { name: "Villalba" },
          { name: "Yabucoa" },
          { name: "Yauco" }
        ]
      },
      {
        country: "Qatar",
        code: "+974",
        states: [
          { name: "Al Daayen" },
          { name: "Al Khor" },
          { name: "Al Rayyan" },
          { name: "Al Shahaniya" },
          { name: "Al Shamal" },
          { name: "Doha" },
          { name: "Madinat ash Shamal" },
          { name: "Umm Salal" },
          { name: "Al Wakrah" }
        ]
      },
      {
        country: "Romania",
        code: "+40",
        states: [
          { name: "Alba" },
          { name: "Arad" },
          { name: "Argeș" },
          { name: "Bacău" },
          { name: "Bihor" },
          { name: "Bistrița-Năsăud" },
          { name: "Botoșani" },
          { name: "Brașov" },
          { name: "Brăila" },
          { name: "Bucharest" },
          { name: "Buzău" },
          { name: "Călărași" },
          { name: "Caraș-Severin" },
          { name: "Cluj" },
          { name: "Constanța" },
          { name: "Covasna" },
          { name: "Dâmbovița" },
          { name: "Dolj" },
          { name: "Galați" },
          { name: "Giurgiu" },
          { name: "Gorj" },
          { name: "Harghita" },
          { name: "Hunedoara" },
          { name: "Ialomița" },
          { name: "Iași" },
          { name: "Ilfov" },
          { name: "Maramureș" },
          { name: "Mehedinți" },
          { name: "Mureș" },
          { name: "Neamț" },
          { name: "Olt" },
          { name: "Prahova" },
          { name: "Sălaj" },
          { name: "Satu Mare" },
          { name: "Sibiu" },
          { name: "Suceava" },
          { name: "Teleorman" },
          { name: "Timiș" },
          { name: "Tulcea" },
          { name: "Vâlcea" },
          { name: "Vaslui" },
          { name: "Vrancea" }
        ]
      },
      {
        country: "Russia",
        code: "+7",
        states: [
          { name: "Adygea" },
          { name: "Altai Republic" },
          { name: "Bashkortostan" },
          { name: "Buryatia" },
          { name: "Chechnya" },
          { name: "Chuvashia" },
          { name: "Dagestan" },
          { name: "Ingushetia" },
          { name: "Kabardino-Balkaria" },
          { name: "Kalmykia" },
          { name: "Karachay-Cherkessia" },
          { name: "Karelia" },
          { name: "Komi" },
          { name: "Mari El" },
          { name: "Mordovia" },
          { name: "North Ossetia–Alania" },
          { name: "Sakha (Yakutia)" },
          { name: "Tatarstan" },
          { name: "Tuva" },
          { name: "Udmurt" },
          { name: "Altai Krai" },
          { name: "Krasnodar Krai" },
          { name: "Krasnoyarsk Krai" },
          { name: "Primorsky Krai" },
          { name: "Stavropol Krai" },
          { name: "Amur Oblast" },
          { name: "Arkhangelsk Oblast" },
          { name: "Astrakhan Oblast" },
          { name: "Belgorod Oblast" },
          { name: "Bryansk Oblast" },
          { name: "Chelyabinsk Oblast" },
          { name: "Irkutsk Oblast" },
          { name: "Ivanovo Oblast" },
          { name: "Kaliningrad Oblast" },
          { name: "Kaluga Oblast" },
          { name: "Kemerovo Oblast" },
          { name: "Kirov Oblast" },
          { name: "Kostroma Oblast" },
          { name: "Kurgan Oblast" },
          { name: "Kursk Oblast" },
          { name: "Leningrad Oblast" },
          { name: "Lipetsk Oblast" },
          { name: "Magadan Oblast" },
          { name: "Moscow Oblast" },
          { name: "Murmansk Oblast" },
          { name: "Nizhny Novgorod Oblast" },
          { name: "Novgorod Oblast" },
          { name: "Novosibirsk Oblast" },
          { name: "Omsk Oblast" },
          { name: "Orenburg Oblast" },
          { name: "Oryol Oblast" },
          { name: "Penza Oblast" },
          { name: "Pskov Oblast" },
          { name: "Rostov Oblast" },
          { name: "Ryazan Oblast" },
          { name: "Sakhalin Oblast" },
          { name: "Samara Oblast" },
          { name: "Saratov Oblast" },
          { name: "Smolensk Oblast" },
          { name: "Sverdlovsk Oblast" },
          { name: "Tambov Oblast" },
          { name: "Tomsk Oblast" },
          { name: "Tula Oblast" },
          { name: "Tver Oblast" },
          { name: "Tyumen Oblast" },
          { name: "Ulyanovsk Oblast" },
          { name: "Vladimir Oblast" },
          { name: "Volgograd Oblast" },
          { name: "Vologda Oblast" },
          { name: "Voronezh Oblast" },
          { name: "Moscow" },
          { name: "Saint Petersburg" },
          { name: "Sevastopol" }
        ]
      },
      {
        country: "Rwanda",
        code: "+250",
        states: [
          { name: "Eastern" },
          { name: "Kigali City" },
          { name: "Northern" },
          { name: "Southern" },
          { name: "Western" }
        ]
      },
      {
        country: "Saint Barthelemy",
        code: "+590",
        states: [
          { name: "Gustavia" },
          { name: "Saint-Jean" },
          { name: "Lorient" },
          { name: "Corossol" },
          { name: "Public" },
          { name: "Colombier" }
        ]
      },
      {
        country: "Saint Helena",
        code: "+290",
        states: [
          { name: "Jamestown" },
          { name: "Longwood" },
          { name: "Half Tree Hollow" },
          { name: "Blue Hill" },
          { name: "Levelwood" },
          { name: "Alarm Forest" },
          { name: "St Paul's" }
        ]
      },
      {
        country: "Saint Kitts and Nevis",
        code: "+1869",
        states: [
          { name: "Christ Church Nichola Town" },
          { name: "Saint Anne Sandy Point" },
          { name: "Saint George Basseterre" },
          { name: "Saint George Gingerland" },
          { name: "Saint James Windward" },
          { name: "Saint John Capisterre" },
          { name: "Saint John Figtree" },
          { name: "Saint Mary Cayon" },
          { name: "Saint Paul Capisterre" },
          { name: "Saint Paul Charlestown" },
          { name: "Saint Peter Basseterre" },
          { name: "Saint Thomas Lowland" },
          { name: "Saint Thomas Middle Island" },
          { name: "Trinity Palmetto Point" }
        ]
      },
      {
        country: "Saint Lucia",
        code: "+1758",
        states: [
          { name: "Anse la Raye" },
          { name: "Canaries" },
          { name: "Castries" },
          { name: "Choiseul" },
          { name: "Dennery" },
          { name: "Gros Islet" },
          { name: "Laborie" },
          { name: "Micoud" },
          { name: "Soufrière" },
          { name: "Vieux Fort" }
        ]
      },
      {
        country: "Saint Martin",
        code: "+590",
        states: [
          { name: "Marigot" },
          { name: "Grand-Case" },
          { name: "Orient Bay" },
          { name: "Rambaud" },
          { name: "Colombier" },
          { name: "Quartier d'Orléans" }
        ]
      },
      {
        country: "Saint Pierre and Miquelon",
        code: "+508",
        states: [
          { name: "Saint-Pierre" },
          { name: "Miquelon-Langlade" }
        ]
      },
      {
        country: "Saint Vincent and the Grenadines",
        code: "+1784",
        states: [
          { name: "Charlotte" },
          { name: "Grenadines" },
          { name: "Saint Andrew" },
          { name: "Saint David" },
          { name: "Saint George" },
          { name: "Saint Patrick" }
        ]
      },
      {
        country: "Samoa",
        code: "+685",
        states: [
          { name: "A'ana" },
          { name: "Aiga-i-le-Tai" },
          { name: "Atua" },
          { name: "Fa'asaleleaga" },
          { name: "Gaga'emauga" },
          { name: "Gaga'ifomauga" },
          { name: "Palauli" },
          { name: "Satupa'itea" },
          { name: "Tuamasaga" },
          { name: "Va'a-o-Fonoti" },
          { name: "Vaisigano" }
        ]
      },
      {
        country: "San Marino",
        code: "+378",
        states: [
          { name: "Acquaviva" },
          { name: "Borgo Maggiore" },
          { name: "Chiesanuova" },
          { name: "Domagnano" },
          { name: "Faetano" },
          { name: "Fiorentino" },
          { name: "Montegiardino" },
          { name: "San Marino" },
          { name: "Serravalle" }
        ]
      },
      {
        country: "Sao Tome and Principe",
        code: "+239",
        states: [
          { name: "Água Grande" },
          { name: "Cantagalo" },
          { name: "Caué" },
          { name: "Lembá" },
          { name: "Lobata" },
          { name: "Mé-Zóchi" },
          { name: "Príncipe" }
        ]
      },
      {
        country: "Saudi Arabia",
        code: "+966",
        states: [
          { name: "Al Bahah" },
          { name: "Al Hudud ash Shamaliyah" },
          { name: "Al Jawf" },
          { name: "Al Madinah" },
          { name: "Al Qasim" },
          { name: "Eastern Province" },
          { name: "Hail" },
          { name: "Jizan" },
          { name: "Makkah" },
          { name: "Najran" },
          { name: "Riyadh" },
          { name: "Tabuk" }
        ]
      },
      {
        country: "Senegal",
        code: "+221",
        states: [
          { name: "Dakar" },
          { name: "Diourbel" },
          { name: "Fatick" },
          { name: "Kaffrine" },
          { name: "Kaolack" },
          { name: "Kédougou" },
          { name: "Kolda" },
          { name: "Louga" },
          { name: "Matam" },
          { name: "Saint-Louis" },
          { name: "Sédhiou" },
          { name: "Tambacounda" },
          { name: "Thiès" },
          { name: "Ziguinchor" }
        ]
      },
      {
        country: "Serbia",
        code: "+381",
        states: [
          { name: "Belgrade" },
          { name: "Bor" },
          { name: "Braničevo" },
          { name: "Jablanica" },
          { name: "Kolubara" },
          { name: "Mačva" },
          { name: "Moravica" },
          { name: "Nišava" },
          { name: "Pčinja" },
          { name: "Pirot" },
          { name: "Podunavlje" },
          { name: "Pomoravlje" },
          { name: "Rasina" },
          { name: "Raška" },
          { name: "Šumadija" },
          { name: "Toplica" },
          { name: "Zaječar" },
          { name: "Zapadna Bačka" },
          { name: "Zlatibor" },
          { name: "Autonomous Province of Kosovo and Metohija" },
          { name: "Autonomous Province of Vojvodina" }
        ]
      },
      {
        country: "Seychelles",
        code: "+248",
        states: [
          { name: "Anse Boileau" },
          { name: "Anse Royale" },
          { name: "Baie Lazare" },
          { name: "Beau Vallon" },
          { name: "Bel Air" },
          { name: "Bel Ombre" },
          { name: "Cascade" },
          { name: "Glacis" },
          { name: "Grand'Anse Mahé" },
          { name: "La Digue" },
          { name: "Mont Buxton" },
          { name: "Mont Fleuri" },
          { name: "Plaisance" },
          { name: "Pointe La Rue" },
          { name: "Port Glaud" },
          { name: "Saint Louis" },
          { name: "Takamaka" }
        ]
      },
      {
        country: "Sierra Leone",
        code: "+232",
        states: [
          { name: "Eastern" },
          { name: "Northern" },
          { name: "North Western" },
          { name: "Southern" },
          { name: "Western Area" }
        ]
      },
      {
        country: "Singapore",
        code: "+65",
        states: [
          { name: "Central Singapore" },
          { name: "North East" },
          { name: "North West" },
          { name: "South East" },
          { name: "South West" }
        ]
      },
      {
        country: "Slovakia",
        code: "+421",
        states: [
          { name: "Banská Bystrica" },
          { name: "Bratislava" },
          { name: "Košice" },
          { name: "Nitra" },
          { name: "Prešov" },
          { name: "Trenčín" },
          { name: "Trnava" },
          { name: "Žilina" }
        ]
      },
      {
        country: "Slovenia",
        code: "+386",
        states: [
          { name: "Ajdovščina" },
          { name: "Bled" },
          { name: "Celje" },
          { name: "Domžale" },
          { name: "Jesenice" },
          { name: "Koper" },
          { name: "Kranj" },
          { name: "Ljubljana" },
          { name: "Maribor" },
          { name: "Novo Mesto" },
          { name: "Piran" },
          { name: "Ptuj" },
          { name: "Trbovlje" }
        ]
      },
      {
        country: "Solomon Islands",
        code: "+677",
        states: [
          { name: "Central" },
          { name: "Choiseul" },
          { name: "Guadalcanal" },
          { name: "Honiara" },
          { name: "Isabel" },
          { name: "Makira-Ulawa" },
          { name: "Malaita" },
          { name: "Rennell and Bellona" },
          { name: "Temotu" },
          { name: "Western" }
        ]
      },
      {
        country: "Somalia",
        code: "+252",
        states: [
          { name: "Awdal" },
          { name: "Bakool" },
          { name: "Banaadir" },
          { name: "Bari" },
          { name: "Bay" },
          { name: "Galguduud" },
          { name: "Gedo" },
          { name: "Hiiraan" },
          { name: "Lower Juba" },
          { name: "Lower Shabelle" },
          { name: "Middle Juba" },
          { name: "Middle Shabelle" },
          { name: "Mudug" },
          { name: "Nugal" },
          { name: "Sanaag" },
          { name: "Sool" },
          { name: "Togdheer" },
          { name: "Woqooyi Galbeed" }
        ]
      },
      {
        country: "South Africa",
        code: "+27",
        states: [
          { name: "Eastern Cape" },
          { name: "Free State" },
          { name: "Gauteng" },
          { name: "KwaZulu-Natal" },
          { name: "Limpopo" },
          { name: "Mpumalanga" },
          { name: "North West" },
          { name: "Northern Cape" },
          { name: "Western Cape" }
        ]
      },
      {
        country: "South Sudan",
        code: "+211",
        states: [
          { name: "Central Equatoria" },
          { name: "Eastern Equatoria" },
          { name: "Jonglei" },
          { name: "Lakes" },
          { name: "Northern Bahr el Ghazal" },
          { name: "Unity" },
          { name: "Upper Nile" },
          { name: "Warrap" },
          { name: "Western Bahr el Ghazal" },
          { name: "Western Equatoria" }
        ]
      },
      {
        country: "South Georgia and the South Sandwich Islands",
        code: "+500",
        states: [
          { name: "Bird Island" },
          { name: "South Georgia" },
          { name: "South Sandwich Islands" }
        ]
      },
      {
        country: "Spain",
        code: "+34",
        states: [
          { name: "Andalusia" },
          { name: "Aragon" },
          { name: "Asturias" },
          { name: "Balearic Islands" },
          { name: "Basque Country" },
          { name: "Canary Islands" },
          { name: "Cantabria" },
          { name: "Castile and León" },
          { name: "Castile-La Mancha" },
          { name: "Catalonia" },
          { name: "Extremadura" },
          { name: "Galicia" },
          { name: "La Rioja" },
          { name: "Madrid" },
          { name: "Murcia" },
          { name: "Navarre" },
          { name: "Valencian Community" },
          { name: "Ceuta" },
          { name: "Melilla" }
        ]
      },
      {
        country: "Sri Lanka",
        code: "+94",
        states: [
          { name: "Central" },
          { name: "Eastern" },
          { name: "Northern" },
          { name: "North Central" },
          { name: "North Western" },
          { name: "Sabaragamuwa" },
          { name: "Southern" },
          { name: "Uva" },
          { name: "Western" }
        ]
      },
      {
        country: "Sudan",
        code: "+249",
        states: [
          { name: "Al Jazirah" },
          { name: "Al Qadarif" },
          { name: "Blue Nile" },
          { name: "Central Darfur" },
          { name: "East Darfur" },
          { name: "Kassala" },
          { name: "Khartoum" },
          { name: "North Darfur" },
          { name: "North Kordofan" },
          { name: "Northern" },
          { name: "Red Sea" },
          { name: "River Nile" },
          { name: "Sennar" },
          { name: "South Darfur" },
          { name: "South Kordofan" },
          { name: "West Darfur" },
          { name: "West Kordofan" },
          { name: "White Nile" }
        ]
      },
      {
        country: "Suriname",
        code: "+597",
        states: [
          { name: "Brokopondo" },
          { name: "Commewijne" },
          { name: "Coronie" },
          { name: "Marowijne" },
          { name: "Nickerie" },
          { name: "Para" },
          { name: "Paramaribo" },
          { name: "Saramacca" },
          { name: "Sipaliwini" },
          { name: "Wanica" }
        ]
      },
      {
        country: "Svalbard and Jan Mayen",
        code: "+47",
        states: [
          { name: "Longyearbyen" },
          { name: "Ny-Ålesund" },
          { name: "Barentsburg" },
          { name: "Jan Mayen" }
        ]
      },
      {
        country: "Eswatini",
        code: "+268",
        states: [
          { name: "Hhohho" },
          { name: "Lubombo" },
          { name: "Manzini" },
          { name: "Shiselweni" }
        ]
      },
      {
        country: "Sweden",
        code: "+46",
        states: [
          { name: "Blekinge" },
          { name: "Dalarna" },
          { name: "Gotland" },
          { name: "Gävleborg" },
          { name: "Halland" },
          { name: "Jämtland" },
          { name: "Jönköping" },
          { name: "Kalmar" },
          { name: "Kronoberg" },
          { name: "Norrbotten" },
          { name: "Örebro" },
          { name: "Östergötland" },
          { name: "Skåne" },
          { name: "Södermanland" },
          { name: "Stockholm" },
          { name: "Uppsala" },
          { name: "Värmland" },
          { name: "Västerbotten" },
          { name: "Västernorrland" },
          { name: "Västmanland" },
          { name: "Västra Götaland" }
        ]
      },
      {
        country: "Switzerland",
        code: "+41",
        states: [
          { name: "Aargau" },
          { name: "Appenzell Ausserrhoden" },
          { name: "Appenzell Innerrhoden" },
          { name: "Basel-Landschaft" },
          { name: "Basel-Stadt" },
          { name: "Bern" },
          { name: "Fribourg" },
          { name: "Geneva" },
          { name: "Glarus" },
          { name: "Graubünden" },
          { name: "Jura" },
          { name: "Lucerne" },
          { name: "Neuchâtel" },
          { name: "Nidwalden" },
          { name: "Obwalden" },
          { name: "Schaffhausen" },
          { name: "Schwyz" },
          { name: "Solothurn" },
          { name: "St. Gallen" },
          { name: "Thurgau" },
          { name: "Ticino" },
          { name: "Uri" },
          { name: "Valais" },
          { name: "Vaud" },
          { name: "Zug" },
          { name: "Zürich" }
        ]
      },
      {
        country: "Syrian Arab Republic",
        code: "+963",
        states: [
          { name: "Al-Hasakah" },
          { name: "Al-Raqqah" },
          { name: "Aleppo" },
          { name: "As-Suwayda" },
          { name: "Damascus" },
          { name: "Daraa" },
          { name: "Deir ez-Zor" },
          { name: "Hama" },
          { name: "Homs" },
          { name: "Idlib" },
          { name: "Latakia" },
          { name: "Quneitra" },
          { name: "Rif Dimashq" },
          { name: "Tartus" }
        ]
      },
      {
        country: "Taiwan",
        code: "+886",
        states: [
          { name: "Changhua" },
          { name: "Chiayi" },
          { name: "Hsinchu" },
          { name: "Hualien" },
          { name: "Kaohsiung" },
          { name: "Keelung" },
          { name: "Kinmen" },
          { name: "Lienchiang" },
          { name: "Miaoli" },
          { name: "Nantou" },
          { name: "New Taipei" },
          { name: "Penghu" },
          { name: "Pingtung" },
          { name: "Taichung" },
          { name: "Tainan" },
          { name: "Taipei" },
          { name: "Taitung" },
          { name: "Taoyuan" },
          { name: "Yilan" },
          { name: "Yunlin" }
        ]
      },
      {
        country: "Tajikistan",
        code: "+992",
        states: [
          { name: "Dushanbe" },
          { name: "Gorno-Badakhshan" },
          { name: "Khatlon" },
          { name: "Sughd" },
          { name: "Districts of Republican Subordination" }
        ]
      },
      {
        country: "Tanzania",
        code: "+255",
        states: [
          { name: "Arusha" },
          { name: "Dar es Salaam" },
          { name: "Dodoma" },
          { name: "Geita" },
          { name: "Iringa" },
          { name: "Kagera" },
          { name: "Katavi" },
          { name: "Kigoma" },
          { name: "Kilimanjaro" },
          { name: "Lindi" },
          { name: "Manyara" },
          { name: "Mara" },
          { name: "Mbeya" },
          { name: "Morogoro" },
          { name: "Mtwara" },
          { name: "Mwanza" },
          { name: "Njombe" },
          { name: "Pemba North" },
          { name: "Pemba South" },
          { name: "Pwani" },
          { name: "Rukwa" },
          { name: "Ruvuma" },
          { name: "Shinyanga" },
          { name: "Simiyu" },
          { name: "Singida" },
          { name: "Songwe" },
          { name: "Tabora" },
          { name: "Tanga" },
          { name: "Zanzibar North" },
          { name: "Zanzibar South and Central" },
          { name: "Zanzibar West" }
        ]
      },
      {
        country: "Thailand",
        code: "+66",
        states: [
          { name: "Amnat Charoen" },
          { name: "Ang Thong" },
          { name: "Bangkok" },
          { name: "Buri Ram" },
          { name: "Chachoengsao" },
          { name: "Chai Nat" },
          { name: "Chaiyaphum" },
          { name: "Chanthaburi" },
          { name: "Chiang Mai" },
          { name: "Chiang Rai" },
          { name: "Chon Buri" },
          { name: "Chumphon" },
          { name: "Kalasin" },
          { name: "Kamphaeng Phet" },
          { name: "Kanchanaburi" },
          { name: "Khon Kaen" },
          { name: "Krabi" },
          { name: "Lampang" },
          { name: "Lamphun" },
          { name: "Loei" },
          { name: "Lop Buri" },
          { name: "Mae Hong Son" },
          { name: "Maha Sarakham" },
          { name: "Mukdahan" },
          { name: "Nakhon Nayok" },
          { name: "Nakhon Pathom" },
          { name: "Nakhon Phanom" },
          { name: "Nakhon Ratchasima" },
          { name: "Nakhon Sawan" },
          { name: "Nakhon Si Thammarat" },
          { name: "Nan" },
          { name: "Narathiwat" },
          { name: "Nong Bua Lam Phu" },
          { name: "Nong Khai" },
          { name: "Nonthaburi" },
          { name: "Pathum Thani" },
          { name: "Pattani" },
          { name: "Phang Nga" },
          { name: "Phatthalung" },
          { name: "Phayao" },
          { name: "Phetchabun" },
          { name: "Phetchaburi" },
          { name: "Phichit" },
          { name: "Phitsanulok" },
          { name: "Phra Nakhon Si Ayutthaya" },
          { name: "Phrae" },
          { name: "Phuket" },
          { name: "Prachin Buri" },
          { name: "Prachuap Khiri Khan" },
          { name: "Ranong" },
          { name: "Ratchaburi" },
          { name: "Rayong" },
          { name: "Roi Et" },
          { name: "Sa Kaeo" },
          { name: "Sakon Nakhon" },
          { name: "Samut Prakan" },
          { name: "Samut Sakhon" },
          { name: "Samut Songkhram" },
          { name: "Saraburi" },
          { name: "Satun" },
          { name: "Sing Buri" },
          { name: "Sisaket" },
          { name: "Songkhla" },
          { name: "Sukhothai" },
          { name: "Suphan Buri" },
          { name: "Surat Thani" },
          { name: "Surin" },
          { name: "Tak" },
          { name: "Trang" },
          { name: "Trat" },
          { name: "Ubon Ratchathani" },
          { name: "Udon Thani" },
          { name: "Uthai Thani" },
          { name: "Uttaradit" },
          { name: "Yala" },
          { name: "Yasothon" }
        ]
      },
      {
        country: "Timor-Leste",
        code: "+670",
        states: [
          { name: "Aileu" },
          { name: "Ainaro" },
          { name: "Baucau" },
          { name: "Bobonaro" },
          { name: "Cova Lima" },
          { name: "Dili" },
          { name: "Ermera" },
          { name: "Lautém" },
          { name: "Liquiçá" },
          { name: "Manatuto" },
          { name: "Manufahi" },
          { name: "Viqueque" }
        ]
      },
      {
        country: "Togo",
        code: "+228",
        states: [
          { name: "Centrale" },
          { name: "Kara" },
          { name: "Maritime" },
          { name: "Plateaux" },
          { name: "Savanes" }
        ]
      },
      {
        country: "Tokelau",
        code: "+690",
        states: [
          { name: "Atafu" },
          { name: "Fakaofo" },
          { name: "Nukunonu" }
        ]
      },
      {
        country: "Tonga",
        code: "+676",
        states: [
          { name: "Ha'apai" },
          { name: "ʻEua" },
          { name: "Niuas" },
          { name: "Tongatapu" },
          { name: "Vavaʻu" }
        ]
      },
      {
        country: "Trinidad and Tobago",
        code: "+1868",
        states: [
          { name: "Arima" },
          { name: "Chaguanas" },
          { name: "Couva-Tabaquite-Talparo" },
          { name: "Diego Martin" },
          { name: "Mayaro-Rio Claro" },
          { name: "Penal-Debe" },
          { name: "Point Fortin" },
          { name: "Port of Spain" },
          { name: "Princes Town" },
          { name: "San Fernando" },
          { name: "San Juan-Laventille" },
          { name: "Sangre Grande" },
          { name: "Siparia" },
          { name: "Tobago" },
          { name: "Tunapuna-Piarco" }
        ]
      },
      {
        country: "Tunisia",
        code: "+216",
        states: [
          { name: "Ariana" },
          { name: "Béja" },
          { name: "Ben Arous" },
          { name: "Bizerte" },
          { name: "Gabès" },
          { name: "Gafsa" },
          { name: "Jendouba" },
          { name: "Kairouan" },
          { name: "Kasserine" },
          { name: "Kebili" },
          { name: "Kef" },
          { name: "Mahdia" },
          { name: "Manouba" },
          { name: "Medenine" },
          { name: "Monastir" },
          { name: "Nabeul" },
          { name: "Sfax" },
          { name: "Sidi Bouzid" },
          { name: "Siliana" },
          { name: "Sousse" },
          { name: "Tataouine" },
          { name: "Tozeur" },
          { name: "Tunis" },
          { name: "Zaghouan" }
        ]
      },
      {
        country: "Turkey",
        code: "+90",
        states: [
          { name: "Adana" },
          { name: "Adıyaman" },
          { name: "Afyonkarahisar" },
          { name: "Ağrı" },
          { name: "Aksaray" },
          { name: "Amasya" },
          { name: "Ankara" },
          { name: "Antalya" },
          { name: "Ardahan" },
          { name: "Artvin" },
          { name: "Aydın" },
          { name: "Balıkesir" },
          { name: "Bartın" },
          { name: "Batman" },
          { name: "Bayburt" },
          { name: "Bilecik" },
          { name: "Bingöl" },
          { name: "Bitlis" },
          { name: "Bolu" },
          { name: "Burdur" },
          { name: "Bursa" },
          { name: "Çanakkale" },
          { name: "Çankırı" },
          { name: "Çorum" },
          { name: "Denizli" },
          { name: "Diyarbakır" },
          { name: "Düzce" },
          { name: "Edirne" },
          { name: "Elazığ" },
          { name: "Erzincan" },
          { name: "Erzurum" },
          { name: "Eskişehir" },
          { name: "Gaziantep" },
          { name: "Giresun" },
          { name: "Gümüşhane" },
          { name: "Hakkari" },
          { name: "Hatay" },
          { name: "Iğdır" },
          { name: "Isparta" },
          { name: "Istanbul" },
          { name: "İzmir" },
          { name: "Kahramanmaraş" },
          { name: "Karabük" },
          { name: "Karaman" },
          { name: "Kars" },
          { name: "Kastamonu" },
          { name: "Kayseri" },
          { name: "Kilis" },
          { name: "Kırıkkale" },
          { name: "Kırklareli" },
          { name: "Kırşehir" },
          { name: "Kocaeli" },
          { name: "Konya" },
          { name: "Kütahya" },
          { name: "Malatya" },
          { name: "Manisa" },
          { name: "Mardin" },
          { name: "Mersin" },
          { name: "Muğla" },
          { name: "Muş" },
          { name: "Nevşehir" },
          { name: "Niğde" },
          { name: "Ordu" },
          { name: "Osmaniye" },
          { name: "Rize" },
          { name: "Sakarya" },
          { name: "Samsun" },
          { name: "Şanlıurfa" },
          { name: "Siirt" },
          { name: "Sinop" },
          { name: "Şırnak" },
          { name: "Sivas" },
          { name: "Tekirdağ" },
          { name: "Tokat" },
          { name: "Trabzon" },
          { name: "Tunceli" },
          { name: "Uşak" },
          { name: "Van" },
          { name: "Yalova" },
          { name: "Yozgat" },
          { name: "Zonguldak" }
        ]
      },
      {
        country: "Turkmenistan",
        code: "+993",
        states: [
          { name: "Ahal" },
          { name: "Balkan" },
          { name: "Dashoguz" },
          { name: "Lebap" },
          { name: "Mary" },
          { name: "Ashgabat" }
        ]
      },
      {
        country: "Turks and Caicos Islands",
        code: "+1649",
        states: [
          { name: "Grand Turk" },
          { name: "South Caicos" },
          { name: "Middle Caicos" },
          { name: "North Caicos" },
          { name: "Providenciales" },
          { name: "Salt Cay" }
        ]
      },
      {
        country: "Tuvalu",
        code: "+688",
        states: [
          { name: "Funafuti" },
          { name: "Nanumanga" },
          { name: "Nanumea" },
          { name: "Niutao" },
          { name: "Nui" },
          { name: "Nukufetau" },
          { name: "Nukulaelae" },
          { name: "Vaitupu" }
        ]
      },
      {
        country: "Uganda",
        code: "+256",
        states: [
          { name: "Central Region" },
          { name: "Eastern Region" },
          { name: "Northern Region" },
          { name: "Western Region" }
        ]
      },
      {
        country: "Ukraine",
        code: "+380",
        states: [
          { name: "Cherkasy" },
          { name: "Chernihiv" },
          { name: "Chernivtsi" },
          { name: "Dnipropetrovsk" },
          { name: "Donetsk" },
          { name: "Ivano-Frankivsk" },
          { name: "Kharkiv" },
          { name: "Kherson" },
          { name: "Khmelnytskyi" },
          { name: "Kirovohrad" },
          { name: "Kyiv" },
          { name: "Luhansk" },
          { name: "Lviv" },
          { name: "Mykolaiv" },
          { name: "Odessa" },
          { name: "Poltava" },
          { name: "Rivne" },
          { name: "Sumy" },
          { name: "Ternopil" },
          { name: "Vinnytsia" },
          { name: "Volyn" },
          { name: "Zakarpattia" },
          { name: "Zaporizhzhia" },
          { name: "Zhytomyr" }
        ]
      },
      {
        country: "United Arab Emirates",
        code: "+971",
        states: [
          { name: "Abu Dhabi" },
          { name: "Ajman" },
          { name: "Dubai" },
          { name: "Fujairah" },
          { name: "Ras Al Khaimah" },
          { name: "Sharjah" },
          { name: "Umm Al Quwain" }
        ]
      },
      {
        country: "United Kingdom",
        code: "+44",
        states: [
          { name: "England" },
          { name: "Scotland" },
          { name: "Wales" },
          { name: "Northern Ireland" }
        ]
      },
      {
        country: "Uruguay",
        code: "+598",
        states: [
          { name: "Artigas" },
          { name: "Canelones" },
          { name: "Cerro Largo" },
          { name: "Colonia" },
          { name: "Durazno" },
          { name: "Flores" },
          { name: "Florida" },
          { name: "Lavalleja" },
          { name: "Maldonado" },
          { name: "Montevideo" },
          { name: "Paysandú" },
          { name: "Río Negro" },
          { name: "Rivera" },
          { name: "Rocha" },
          { name: "Salto" },
          { name: "San José" },
          { name: "Soriano" },
          { name: "Tacuarembó" },
          { name: "Treinta y Tres" }
        ]
      },
      {
        country: "Uzbekistan",
        code: "+998",
        states: [
          { name: "Andijan" },
          { name: "Bukhara" },
          { name: "Fergana" },
          { name: "Jizzakh" },
          { name: "Namangan" },
          { name: "Navoiy" },
          { name: "Qashqadaryo" },
          { name: "Karakalpakstan" },
          { name: "Samarqand" },
          { name: "Sirdaryo" },
          { name: "Surxondaryo" },
          { name: "Tashkent" },
          { name: "Tashkent City" },
          { name: "Xorazm" }
        ]
      },
      {
        country: "Vanuatu",
        code: "+678",
        states: [
          { name: "Malampa" },
          { name: "Pénama" },
          { name: "Sanma" },
          { name: "Shefa" },
          { name: "Tafea" },
          { name: "Torba" }
        ]
      },
      {
        country: "Venezuela",
        code: "+58",
        states: [
          { name: "Amazonas" },
          { name: "Anzoátegui" },
          { name: "Apure" },
          { name: "Aragua" },
          { name: "Barinas" },
          { name: "Bolívar" },
          { name: "Carabobo" },
          { name: "Cojedes" },
          { name: "Delta Amacuro" },
          { name: "Falcón" },
          { name: "Guárico" },
          { name: "Lara" },
          { name: "Mérida" },
          { name: "Miranda" },
          { name: "Monagas" },
          { name: "Nueva Esparta" },
          { name: "Portuguesa" },
          { name: "Sucre" },
          { name: "Táchira" },
          { name: "Trujillo" },
          { name: "Vargas" },
          { name: "Yaracuy" },
          { name: "Zulia" },
          { name: "Dependencias Federales" },
          { name: "Distrito Capital" }
        ]
      },
      {
        country: "Virgin Islands, British",
        code: "+1284",
        states: [
          { name: "Anegada" },
          { name: "Jost Van Dyke" },
          { name: "Tortola" },
          { name: "Virgin Gorda" }
        ]
      },
      {
        country: "Virgin Islands, U.S.",
        code: "+1340",
        states: [
          { name: "Saint Croix" },
          { name: "Saint John" },
          { name: "Saint Thomas" }
        ]
      },
      {
        country: "Wallis and Futuna",
        code: "+681",
        states: [
          { name: "Alo" },
          { name: "Sigave" },
          { name: "Uvea" }
        ]
      },
      {
        country: "Yemen",
        code: "+967",
        states: [
          { name: "Abyan" },
          { name: "Aden" },
          { name: "Al Bayda" },
          { name: "Al Hudaydah" },
          { name: "Al Jawf" },
          { name: "Al Mahrah" },
          { name: "Al Mahwit" },
          { name: "Dhamar" },
          { name: "Hadramaut" },
          { name: "Hajjah" },
          { name: "Ibb" },
          { name: "Lahij" },
          { name: "Ma'rib" },
          { name: "Raymah" },
          { name: "Saada" },
          { name: "Sana'a" },
          { name: "Shabwah" },
          { name: "Socotra" },
          { name: "Taiz" }
        ]
      },
      {
        country: "Zambia",
        code: "+260",
        states: [
          { name: "Central" },
          { name: "Copperbelt" },
          { name: "Eastern" },
          { name: "Luapula" },
          { name: "Lusaka" },
          { name: "Muchinga" },
          { name: "Northern" },
          { name: "North-Western" },
          { name: "Southern" },
          { name: "Western" }
        ]
      },
      {
        country: "Zimbabwe",
        code: "+263",
        states: [
          { name: "Bulawayo" },
          { name: "Harare" },
          { name: "Manicaland" },
          { name: "Mashonaland Central" },
          { name: "Mashonaland East" },
          { name: "Mashonaland West" },
          { name: "Masvingo" },
          { name: "Matabeleland North" },
          { name: "Matabeleland South" },
          { name: "Midlands" }
        ]
      }
  ]
